<template>
  <!-- <card :header-text="'Calculated Data '+ company.companyname"> -->
  <div class="card" v-if="company">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{'Calculated Data '+ company.companyname}}</strong>
          {{(rawData.last_updated)? 'Last Updated: '+getDate(rawData.last_updated): ''}}
        </div>
        <div class="col-md-5">
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-primary" @click.prevent="editCompany(company)">
              <i :title="'Edit'" class="fa fa-edit cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <router-link
              class="btn btn-sm btn-small btn-secondary"
              :to="{name: 'pTrends', props: { isIndividual: 0 } }"
            >
              <i :title="'P Trends'" class="fa fa-area-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-danger" to="/company-price-analysis">
              <i :title="'Price Analysis'" class="fa fa-money cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-dark" to="/company-prices-graph">
              <i :title="'Company Price Ghart'" class="fa fa-line-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-info" to="/rawdata">
              <i :title="'Raw Data'" class="fa fa-list cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-success" @click.prevent="showCompDetails(company)">
              <i :title="'View Details'" class="fa fa-eye cwhite"></i>
            </a>
          </div>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <vue-tabs direction="horizontal" @tab-change="getTabData">
        <v-tab :title="alg.name" v-for="(alg, index) in tabs" v-bind:key="index">
          <div class="mb5"></div>
          <div class="row mb5">
            <div class="col-md-8"></div>
            <div class="col-md-3">
              <div class="pull-right">
                <star-rating
                  v-if="alg.title==='q1_a' || alg.title==='q1_b' || alg.title==='q1_c' || alg.title==='q1_d'"
                  v-bind:increment="0.5"
                  v-bind:max-rating="5"
                  :rating="rawData[actTab].rating"
                  :read-only="true"
                  :show-rating="false"
                  inactive-color="#868e96"
                  active-color="#ffbf00"
                  v-bind:star-size="20"
                ></star-rating>
                <star-rating
                  v-if="alg.title==='p11'"
                  v-bind:increment="0.5"
                  v-bind:max-rating="7"
                  :rating="rawData[actTab].rating"
                  :read-only="true"
                  :show-rating="false"
                  inactive-color="#868e96"
                  active-color="#ffbf00"
                  v-bind:star-size="20"
                ></star-rating>
              </div>
            </div>
            <div class="col-md-1">
              <!-- <button type="button" @click="updateCalculatedData" class="btn btn-sm btn-success">
                <i class="fa fa-refresh" title="Update Algos"></i>
              </button>&nbsp;&nbsp;-->
              <div class="pull-right">
                <!-- <button
                  v-on:click="tableToExcel(alg.name,'calculated-data')"
                  class="btn btn-primary btn-sm"
                >
                  <i class="fa fa-download" title="Download Excel"></i>
                </button>-->
                <download :tableId="alg.name" :fileName="alg.name+'-calculated-data'"></download>
              </div>
            </div>
          </div>
          <div class="table-responsive" v-dragscroll="true">
            <!-- <div class="row mb5">
              <div class="col-md-10">         
                <h4 class="subtitle" v-if="actTab === 's1'">Valuation</h4>
              </div>
            </div>-->
            <table
              :id="alg.name"
              class="table"
              :class="(actTab ==='return_analysis' || actTab ==='return_one_analysis' || actTab !== 'years')? '': 'table-bordered'"
              style="font-size: 11px;"
              v-if="actTab !== 'years'"
            >
              <div
                class="mb5"
                v-if="actTab === 'return_analysis' || actTab === 'return_one_analysis'"
              >
                <div v-if="rawData[actTab].all.at_average_pe">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Final Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(fin, index) in tableRowsRAFinal" :key="index+'final'+fin.title">
                      <td>{{fin.name}}</td>
                      <td>{{getFixed(rawData[actTab].all[fin.title])}}</td>
                    </tr>
                  </tbody>
                </div>
                <div v-if="rawData[actTab]['at_average_pe']">
                  <div v-for="(tbtr, index, key) in tableRowsRA1" v-bind:key="key+'-rarow-'+index">
                    <thead >
                      <tr>
                        <th>{{tbtr.name}}</th>
                        <th
                          :colspan="rawData[actTab]['at_average_pe']['net_cash_flow'].length"
                        >{{getFixed(rawData[actTab][tbtr.title].value)}}</th>
                      </tr>
                    </thead>
                    <tbody v-for="(tbcol, ind) in tableRowsRASubRow" v-bind:key="'RAcol'+ind">
                      <tr v-if="typeof rawData[actTab][tbtr.title][tbcol.title] === 'object'">
                        <td>{{(tbcol.name==='')? tbtr.name: tbcol.name}}</td>
                        <td v-if="tbcol.title === 'inflow_dividend'"></td>
                        <td
                          v-for="(tb, i) in rawData[actTab][tbtr.title][tbcol.title]"
                          :key="ind+'ra'+i"
                        >
                          <span></span>
                          {{getChecknFixed(tb)}}
                        </td>
                        <!-- <div v-if="typeof rawData[actTab][tbtr.title][tbcol.title] === 'object'">
                        <td  
                        :colspan="(rawData[actTab][tbtr.title][tbcol.title].length<rawData[actTab]['at_average_pe']['net_cash_flow'].length)? rawData[actTab]['at_average_pe']['net_cash_flow'].length: ''"
                        v-for="tb in rawData[actTab][tbtr.title][tbcol.title]">{{getChecknFixed(tb)}} </td>
                      </div>
                      <div v-else>
                        <td  :colspan="rawData[actTab]['at_average_pe']['net_cash_flow'].length">{{rawData[actTab][tbtr.title][tbcol.title]}}</td>
                        </div>-->
                      </tr>
                      <tr v-else>
                        <td>{{(tbcol.name==='')? tbtr.name: tbcol.name}}</td>
                        <td>{{getChecknFixed(rawData[actTab][tbtr.title][tbcol.title])}}</td>
                      </tr>
                    </tbody>
                    <br />
                  </div>
                </div>
                <div>
                  <tbody v-for="(tbtr, index) in tableRowsRA3" v-bind:key="'ra3row'+index">
                    <tr v-if="rawData[actTab][tbtr.title]">
                      <td class="text-bold">{{tbtr.name}}</td>
                      <td>{{(getUnit(tbtr.name)==='%')? rawData[actTab][tbtr.title]: getChecknFixed(rawData[actTab][tbtr.title])}}</td>
                    </tr>
                  </tbody>
                  <br />
                  <tbody v-for="(tbtr, index) in tableRowsRA4" v-bind:key="'ra3row'+index">
                    <tr v-if="rawData[actTab][tbtr.title]">
                      <td class="text-bold">{{tbtr.name}}</td>
                      <td>{{(getUnit(tbtr.name)==='%')? rawData[actTab][tbtr.title]: getChecknFixed(rawData[actTab][tbtr.title])}}</td>
                    </tr>
                  </tbody>
                  <br />
                  <tbody v-for="(tbtr, index) in tableRowsRA5" v-bind:key="'ra3row'+index">
                    <tr v-if="rawData[actTab][tbtr.title]">
                      <td class="text-bold">{{tbtr.name}}</td>
                      <td>{{(getUnit(tbtr.name)==='%')? rawData[actTab][tbtr.title]: getChecknFixed(rawData[actTab][tbtr.title])}}</td>
                    </tr>
                  </tbody>
                  <br />
                  <br />
                </div>
                <div>
                  <div v-for="(tbtr, index) in tableRowsRA2" v-bind:key="'rarow'+index">
                    <thead v-if="rawData[actTab][tbtr.title]">
                      <tr>
                        <th>{{tbtr.name}}</th>
                        <th
                          :colspan="rawData[actTab]['at_average_pe']['net_cash_flow'].length"
                        >
                        Growth Rate: {{getFixed(rawData[actTab][tbtr.title].value[0])}} PE: {{getFixed(rawData[actTab][tbtr.title].value[1])}}
                        </th>
                      </tr>
                    </thead>
                    <tbody v-for="(tbcol, ind) in tableRowsRASubRow" v-bind:key="'RAcol'+ind">
                      <tr v-if="rawData[actTab][tbtr.title] && typeof rawData[actTab][tbtr.title][tbcol.title] === 'object'">
                        <td>{{(tbcol.name==='')? tbtr.name: tbcol.name}}</td>
                        <td v-if="tbcol.title === 'inflow_dividend'"></td>
                        <td v-for="(tb, i) in rawData[actTab][tbtr.title][tbcol.title]" :key="'ra'+i">
                          <span></span>
                          {{getChecknFixed(tb)}}
                        </td>
                        <!-- <div v-if="typeof rawData[actTab][tbtr.title][tbcol.title] === 'object'">
                        <td  
                        :colspan="(rawData[actTab][tbtr.title][tbcol.title].length<rawData[actTab]['at_average_pe']['net_cash_flow'].length)? rawData[actTab]['at_average_pe']['net_cash_flow'].length: ''"
                        v-for="tb in rawData[actTab][tbtr.title][tbcol.title]">{{getChecknFixed(tb)}} </td>
                      </div>
                      <div v-else>
                        <td  :colspan="rawData[actTab]['at_average_pe']['net_cash_flow'].length">{{rawData[actTab][tbtr.title][tbcol.title]}}</td>
                        </div>-->
                      </tr>
                      <tr v-else-if="rawData[actTab][tbtr.title]">
                        <td>{{(tbcol.name==='')? tbtr.name: tbcol.name}}</td>
                        <td>{{getChecknFixed(rawData[actTab][tbtr.title][tbcol.title])}}</td>
                      </tr>
                    </tbody>
                    <br />
                  </div>
                </div>
              </div>
              <!---actTab !== 'p11' && actTab !== 'p9' && actTab !== 'return_analysis' -->
              <div class="mb5">
                <thead v-if="checkInArray(pTabs, actTab)">
                  <tr>
                    <th></th>
                    <th v-for="tbcol in tableColsP" v-bind:key="'p1year'+tbcol.title">{{tbcol.name}}</th>
                  </tr>
                </thead>
                <div v-if="actTab === 'p9'">
                  <tbody
                    v-for="(tbtr, rind) in tableP9Rows"
                    v-bind:key="'yeardata'+tbtr.title+rind"
                  >
                    <tr>
                      <th>{{tbtr.name}}</th>
                      <th
                        v-for="tbcol in tableColsP"
                        v-bind:key="'p1year'+tbcol.title"
                      >{{tbcol.name}}</th>
                    </tr>
                    <tr
                      v-for="(tbr, rind) in tbtr.subFields"
                      v-bind:key="'yeardata'+tbr.title+rind"
                    >
                      <td>{{tbr.name}}</td>
                      <td v-for="tbcol in tableColsP" v-bind:key="'p1year'+tbcol.title">
                        <!-- {{tbtr.title}} - {{tbr.title}} - {{tbcol.title}} -->
                        <span
                          v-if="tbr.title === 'rank' && tbcol.title === 'rank'"
                        >{{rawData[actTab][tbtr.title][tbr.title]}}</span>
                        <span
                          v-else
                        >{{(tbcol.title === 'rank')? rawData[actTab][tbtr.title][tbr.title][tbcol.title]:getChecknFixed(rawData[actTab][tbtr.title][tbr.title][tbcol.title])}}</span>
                      </td>
                    </tr>
                    <br />
                  </tbody>
                </div>
                <div v-if="actTab === 'p11'">
                  <!-- <div > -->
                  <!-- <thead>
                      <tr>
                        <th>{{tbtr.name}}</th>
                        <th
                          v-for="tbcol in tableColsP"
                          v-bind:key="'p1year'+tbcol.title"
                        >{{tbcol.name}}</th>
                      </tr>
                  </thead >-->
                  <tbody
                    v-for="(tbtr, rind) in tableP11Rows"
                    v-bind:key="'yeardata'+tbtr.title+rind"
                  >
                    <tr>
                      <th>{{tbtr.name}}</th>
                      <th
                        v-for="tbcol in tableColsP"
                        v-bind:key="'p1year'+tbcol.title"
                      >{{tbcol.name}}</th>
                    </tr>
                    <tr
                      v-for="(tbr, rind) in tbtr.subFields"
                      v-bind:key="'yeardata'+tbr.title+rind"
                    >
                      <td>{{tbr.name}}</td>
                      <td v-for="(tbcol, ind) in tableColsP" v-bind:key="'yearcol'+tbcol.title+ind">
                        <!-- {{actTab}} - {{tbtr.title}} - {{tbcol.title}} - {{tbr.title}} -->
                        {{getChecknFixed(rawData[actTab][tbtr.title][tbcol.title][tbr.title])}}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5">Sum</td>
                      <td>{{getChecknFixed(rawData[actTab][tbtr.title].sum)}}</td>
                      <td>{{getChecknFixed(rawData[actTab][tbtr.title].super_weight)}}</td>
                      <td>{{getChecknFixed(rawData[actTab][tbtr.title].super_sum)}}</td>
                    </tr>
                    <br />
                  </tbody>
                  <!-- </div> -->
                  <tr>
                    <td colspan="6"></td>
                    <td>{{getChecknFixed(rawData[actTab].super_weight)}}</td>
                    <td>{{getChecknFixed(rawData[actTab].super_sum)}}</td>
                  </tr>
                </div>
                <div v-if="actTab === 'p1'">
                  <thead>
                    <tr>
                      <th></th>
                      <th
                        v-for="tbcol in tableColsP"
                        v-bind:key="'p1year'+tbcol.title"
                      >{{tbcol.name}}</th>
                    </tr>
                  </thead>
                  <tbody v-for="(tbtr, rind) in tableRows_p1" v-bind:key="'yearrow'+tbtr+rind">
                    <tr>
                      <td class="text-bold" :colspan="tbtr.subFields.length">{{tbtr.name}}</td>
                    </tr>
                    <tr v-for="(sub, sInd) in tbtr.subFields" v-bind:key="'yearrow'+tbtr+sInd">
                      <td>{{sub.name}}</td>
                      <td v-for="(tbcol, ind) in tableColsP" v-bind:key="'yearcol'+tbcol.title+ind">
                        <span
                          v-if="tbcol.title === 'actual' "
                        >{{(sub.title=='outstanding_shares')? getChecknFixed(rawData[actTab][tbcol.title][sub.title]): getChecknFixed(rawData[actTab][tbcol.title][sub.title])}}</span>
                        <span v-else>{{getChecknFixed(rawData[actTab][tbcol.title][sub.title])}}</span>
                      </td>
                    </tr>

                    <tr v-if="actTab === 'p7_a'">
                      <td colspan="5">Final Verdict</td>
                      <td>{{rawData[actTab].final_verdict}}</td>
                    </tr>
                  </tbody>
                  <tr>
                    <td colspan="5">Sum</td>
                    <td>{{getChecknFixed(rawData[actTab].sum)}}</td>
                  </tr>
                  <!-- </div> -->
                  <br />
                </div>
                <div v-if="actTab === 'p7_b'">
                  <thead>
                    <tr>
                      <th></th>
                      <th
                        v-for="tbcol in tableColsP"
                        v-bind:key="'p1year'+tbcol.title"
                      >{{tbcol.name}}</th>
                    </tr>
                  </thead>
                  <tbody v-for="(tbtr, rind) in tableRows_p7_b" v-bind:key="'yearrow'+tbtr+rind">
                    <tr>
                      <td class="text-bold" :colspan="tbtr.subFields.length">{{tbtr.name}}</td>
                    </tr>
                    <tr v-for="(sub, sInd) in tbtr.subFields" v-bind:key="'yearrow'+tbtr+sInd">
                      <td>{{sub.name}}</td>
                      <td v-for="(tbcol, ind) in tableColsP" v-bind:key="'yearcol'+tbcol.title+ind">
                        <span
                          v-if="tbcol.title === 'actual' "
                        >{{(sub.title=='outstanding_shares')? getChecknFixed(rawData[actTab][tbcol.title][sub.title]): getChecknFixed(rawData[actTab][tbcol.title][sub.title])}}</span>
                        <span v-else>{{getChecknFixed(rawData[actTab][tbcol.title][sub.title])}}</span>
                      </td>
                    </tr>
                  </tbody>
                  <tr>
                    <td colspan="5">Sum</td>
                    <td>{{getChecknFixed(rawData[actTab].sum)}}</td>
                  </tr>
                  <!-- </div> -->
                  <br />
                </div>
                <div v-if="actTab === 'q1_a_or_b'">
                  <tbody>
                    <tr>
                      <td class="text-bold">Q1 A/B</td>
                      <td class="">{{getChecknFixed(rawData[actTab])}}</td>
                    </tr>
                  </tbody>
                </div>
                <!-- <div > -->
                <tbody
                  v-if="actTab === 'p2' || actTab === 'p3' || actTab === 'p4' || actTab === 'p5_a' || actTab === 'p5_b' || actTab === 'p6_a' || actTab === 'p6_b' || actTab === 'p7_a' || actTab === 'p8_a' || actTab === 'p8_b' || actTab === 'p10' || actTab === 'q1' || actTab === 'q1_a' || actTab === 'q1_b' || actTab === 'q1_c' || actTab === 'q1_d'"
                >
                  <tr v-for="(tbtr, rind) in getCurrentTabData" v-bind:key="'yearrow'+tbtr+rind">
                    <td>{{getLabel(tbtr)}}</td>
                    <td v-for="(tbcol, ind) in tableColsP" v-bind:key="'yearcol'+tbcol.title+ind">
                      <span
                        v-if="typeof (rawData[actTab][tbcol.title][tbtr]) === 'boolean'"
                      >{{ (rawData[actTab][tbcol.title][tbtr])? 'Yes': 'No'}}</span>
                      <span v-else>{{getChecknFixed(rawData[actTab][tbcol.title][tbtr])}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">Sum</td>
                    <td>{{getChecknFixed(rawData[actTab].sum)}}</td>
                  </tr>
                  <tr v-if="actTab === 'p7_a'">
                    <td colspan="5">Final Verdict</td>
                    <td>{{rawData[actTab].final_verdict}}</td>
                  </tr>
                </tbody>
                <tbody
                  v-if="actTab === 'quarterly_trends'"
                >
                  <tr v-for="(tbtr, rind) in tableQtrTrendsRows" v-bind:key="'yearrow'+tbtr+rind">
                    <td>{{getLabel(tbtr)}}</td>
                    <td v-for="(tbcol, ind) in tableColsP" v-bind:key="'yearcol'+tbcol.title+ind">
                      <span
                        v-if="typeof (rawData['p11']['quarterly_trends'][tbcol.title][tbtr]) === 'boolean'"
                      >{{ (rawData['p11']['quarterly_trends'][tbcol.title][tbtr])? 'Yes': 'No'}}</span>
                      <span v-else>{{getChecknFixed(rawData['p11']['quarterly_trends'][tbcol.title][tbtr])}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">Sum</td>
                    <td>{{getChecknFixed(rawData['p11']['quarterly_trends'].sum)}}</td>
                  </tr>
                  <tr v-if="actTab === 'p7_a'">
                    <td colspan="5">Final Verdict</td>
                    <td>{{rawData[actTab].final_verdict}}</td>
                  </tr>
                </tbody>
                <!-- </div> -->
                <br />
              </div>
            </table>
            <table :id="alg.name" class="table fonts11" v-if="actTab === 'years'">
              <thead>
                <tr>
                  <th class="text-bold">P1</th>
                  <th class></th>
                </tr>
              </thead>
              <tbody v-for="(fld, ind) in tableCols1" :key="'p1'+ind">
                <tr v-if="fld.type===1">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableCols"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===1">
                  <td class>{{fld.name}}</td>
                  <td class v-for="tbcol in tableCols" v-bind:key="'yearcol'+tbcol.title">
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
                <tr v-if="fld.type===2">
                  <td class>{{fld.name}}</td>
                  <td>
                    <!-- {{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}}</span>
                    <span v-else-if="fld.dataType==='boolean'">
                      <span
                        v-if="fld.title === 'has_durable_competative_advantage'"
                      >{{(rawData['algo_2'][fld.title] === 0)? 'No': (rawData['algo_2'][fld.title] === 1)? 'Yes': ''}}</span>
                      <span
                        v-else
                      >{{(rawData[actTab][tableCols[0].title][fld.title] === 0)? 'No': (rawData[actTab][tableCols[0].title][fld.title] === 1)? 'Yes': '-'}}</span>
                    </span>
                    <span v-else>{{rawData[actTab][tableCols[0].title][fld.title]}}</span>
                  </td>
                  <td :colspan="tableColsYears.length-1"></td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsAvg"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class>{{fld.name}}</td>
                  <td
                    v-for="(tbcol, ind) in tableColsAvg"
                    v-bind:key="'yearcol'+tbcol.title+ind"
                  >{{getChecknFixed(rawData[actTab][tableColsAvg[0].title][fld.title][tbcol.title])}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsYears"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td>{{fld.name}}</td>
                  <td v-for="tbcol in tableColsYears" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
              </tbody>
              <br />
              <thead>
                <tr>
                  <th class="text-bold">P2</th>
                  <th class></th>
                </tr>
              </thead>
              <tbody v-for="(fld, ind) in tableCols2" :key="'p2'+ind">
                <tr v-if="fld.type===1">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableCols"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===1">
                  <td class>{{fld.name}}</td>
                  <td class v-for="tbcol in tableCols" v-bind:key="'yearcol'+tbcol.title">
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
                <tr v-if="fld.type===2">
                  <td class>{{fld.name}}</td>
                  <td>
                    <!-- {{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}}</span>
                    <span v-else-if="fld.dataType==='boolean'">
                      <span
                        v-if="fld.title === 'has_durable_competative_advantage'"
                      >{{(rawData['algo_2'][fld.title] === 0)? 'No': (rawData['algo_2'][fld.title] === 1)? 'Yes': ''}}</span>
                      <span
                        v-else
                      >{{(rawData[actTab][tableCols[0].title][fld.title] === 0)? 'No': (rawData[actTab][tableCols[0].title][fld.title] === 1)? 'Yes': '-'}}</span>
                    </span>
                    <span v-else>{{rawData[actTab][tableCols[0].title][fld.title]}}</span>
                  </td>
                  <td :colspan="tableColsYears.length-1"></td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsAvg"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class>{{fld.name}}</td>
                  <td
                    v-for="(tbcol, ind) in tableColsAvg"
                    v-bind:key="'yearcol'+tbcol.title+ind"
                  >{{getChecknFixed(rawData[actTab][tableColsAvg[0].title][fld.title][tbcol.title])}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsYears"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td>{{fld.name}}</td>
                  <td v-for="tbcol in tableColsYears" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
              </tbody>
              <br />
              <thead>
                <tr>
                  <th class="text-bold">P3</th>
                  <th class></th>
                </tr>
              </thead>
              <tbody v-for="(fld, ind) in tableCols3" :key="'p3'+ind">
                <tr v-if="fld.type===1">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableCols"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===1">
                  <td class>{{fld.name}}</td>
                  <td class v-for="tbcol in tableCols" v-bind:key="'yearcol'+tbcol.title">
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
                <tr v-if="fld.type===2">
                  <td class>{{fld.name}}</td>
                  <td>
                    <!-- {{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tableCols[0].title][fld.title] === 0)? 'No': (rawData[actTab][tableCols[0].title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tableCols[0].title][fld.title]}}</span>
                  </td>
                  <td :colspan="tableColsYears.length-1"></td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsAvg"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class>{{fld.name}}</td>
                  <td
                    v-for="(tbcol, ind) in tableColsAvg"
                    v-bind:key="'yearcol'+tbcol.title+ind"
                  >{{getChecknFixed(rawData[actTab][tableColsAvg[0].title][fld.title][tbcol.title])}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsYears"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td>{{fld.name}}</td>
                  <td v-for="tbcol in tableColsYears" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
              </tbody>
              <br />
              <thead>
                <tr>
                  <th class="text-bold">P4</th>
                  <th class></th>
                </tr>
              </thead>
              <tbody v-for="(fld, ind) in tableCols4" :key="'p4'+ind">
                <tr v-if="fld.type===1">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableCols"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===1">
                  <td class>{{fld.name}}</td>
                  <td class v-for="tbcol in tableCols" v-bind:key="'yearcol'+tbcol.title">
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
                <tr v-if="fld.type===2">
                  <td class>{{fld.name}}</td>
                  <td>
                    <!-- {{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tableCols[0].title][fld.title] === 0)? 'No': (rawData[actTab][tableCols[0].title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tableCols[0].title][fld.title]}}</span>
                  </td>
                  <td :colspan="tableColsYears.length-1"></td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsAvg"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class>{{fld.name}}</td>
                  <td
                    v-for="(tbcol, ind) in tableColsAvg"
                    v-bind:key="'yearcol'+tbcol.title+ind"
                  >{{getChecknFixed(rawData[actTab][tableColsAvg[0].title][fld.title][tbcol.title])}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsYears"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td>{{fld.name}}</td>
                  <td v-for="tbcol in tableColsYears" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
              </tbody>
              <br />
              <thead>
                <tr>
                  <th class="text-bold">P5</th>
                  <th class></th>
                </tr>
              </thead>
              <tbody v-for="(fld, ind) in tableCols5" :key="'p5'+ind">
                <tr v-if="fld.type===1">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableCols"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===1">
                  <td class>{{fld.name}}</td>
                  <td class v-for="tbcol in tableCols" v-bind:key="'yearcol'+tbcol.title">
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
                <tr v-if="fld.type===2">
                  <td class>{{fld.name}}</td>
                  <td>
                    <!-- {{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tableCols[0].title][fld.title] === 0)? 'No': (rawData[actTab][tableCols[0].title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tableCols[0].title][fld.title]}}</span>
                  </td>
                  <td :colspan="tableColsYears.length-1"></td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsAvg"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class>{{fld.name}}</td>
                  <td
                    v-for="(tbcol, ind) in tableColsAvg"
                    v-bind:key="'yearcol'+tbcol.title+ind"
                  >{{getChecknFixed(rawData[actTab][tableColsAvg[0].title][fld.title][tbcol.title])}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsYears"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td>{{fld.name}}</td>
                  <td v-for="tbcol in tableColsYears" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
              </tbody>
              <br />
              <thead>
                <tr>
                  <th class="text-bold">P6</th>
                  <th class></th>
                </tr>
              </thead>
              <tbody v-for="(fld, ind) in tableCols6" :key="'p6'+ind">
                <tr v-if="fld.type===1">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableCols"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===1">
                  <td class>{{fld.name}}</td>
                  <td class v-for="tbcol in tableCols" v-bind:key="'yearcol'+tbcol.title">
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
                <tr v-if="fld.type===2">
                  <td class>{{fld.name}}</td>
                  <td>
                    <!-- {{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tableCols[0].title][fld.title] === 0)? 'No': (rawData[actTab][tableCols[0].title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tableCols[0].title][fld.title]}}</span>
                  </td>
                  <td :colspan="tableColsYears.length-1"></td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsAvg"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class>{{fld.name}}</td>
                  <td
                    v-for="(tbcol, ind) in tableColsAvg"
                    v-bind:key="'yearcol'+tbcol.title+ind"
                  >{{getChecknFixed(rawData[actTab][tableColsAvg[0].title][fld.title][tbcol.title])}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsYears"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td>{{fld.name}}</td>
                  <td v-for="tbcol in tableColsYears" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
              </tbody>
              <br />
              <thead>
                <tr>
                  <th class="text-bold">P7</th>
                  <th class></th>
                </tr>
              </thead>
              <tbody v-for="(fld, ind) in tableCols7" :key="'p7'+ind">
                <tr v-if="fld.type===1">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableCols"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===1">
                  <td class>{{fld.name}}</td>
                  <td class v-for="tbcol in tableCols" v-bind:key="'yearcol'+tbcol.title">
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
                <tr v-if="fld.type===2">
                  <td class>{{fld.name}}</td>
                  <td>
                    <!-- {{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tableCols[0].title][fld.title] === 0)? 'No': (rawData[actTab][tableCols[0].title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tableCols[0].title][fld.title]}}</span>
                  </td>
                  <td :colspan="tableColsYears.length-1"></td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsAvg"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class>{{fld.name}}</td>
                  <td
                    v-for="(tbcol, ind) in tableColsAvg"
                    v-bind:key="'yearcol'+tbcol.title+ind"
                  >{{getChecknFixed(rawData[actTab][tableColsAvg[0].title][fld.title][tbcol.title])}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsYears"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td>{{fld.name}}</td>
                  <td v-for="tbcol in tableColsYears" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
              </tbody>
              <br />
              <thead>
                <tr>
                  <th class="text-bold">P8</th>
                  <th class></th>
                </tr>
              </thead>
              <tbody v-for="(fld, ind) in tableCols8" :key="'p8'+ind">
                <tr v-if="fld.type===1">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableCols"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===1">
                  <td class>{{fld.name}}</td>
                  <td class v-for="tbcol in tableCols" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
                <tr v-if="fld.type===2">
                  <td class>{{fld.name}}</td>
                  <td>
                    <!-- {{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tableCols[0].title][fld.title] === 0)? 'No': (rawData[actTab][tableCols[0].title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tableCols[0].title][fld.title]}}</span>
                  </td>
                  <td :colspan="tableColsYears.length-1"></td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsAvg"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class>{{fld.name}}</td>
                  <td
                    v-for="(tbcol, ind) in tableColsAvg"
                    v-bind:key="'yearcol'+tbcol.title+ind"
                  >{{getChecknFixed(rawData[actTab][tableColsAvg[0].title][fld.title][tbcol.title])}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsYears"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td>{{fld.name}}</td>
                  <td v-for="tbcol in tableColsYears" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
              </tbody>
              <br />
              <thead>
                <tr>
                  <th class="text-bold">P9</th>
                  <th class></th>
                </tr>
              </thead>
              <tbody v-for="(fld, ind) in tableCols9" :key="'p9'+ind">
                <tr v-if="fld.type===1">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableCols"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===1">
                  <td class>{{fld.name}}</td>
                  <td class v-for="tbcol in tableCols" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
                <tr v-if="fld.type===2">
                  <td class>{{fld.name}}</td>
                  <td>
                    <!-- {{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tableCols[0].title][fld.title] === 0)? 'No': (rawData[actTab][tableCols[0].title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tableCols[0].title][fld.title]}}</span>
                  </td>
                  <td :colspan="tableColsYears.length-1"></td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsAvg"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class>{{fld.name}}</td>
                  <td
                    v-for="(tbcol, ind) in tableColsAvg"
                    v-bind:key="'yearcol'+tbcol.title+ind"
                  >{{getChecknFixed(rawData[actTab][tableColsAvg[0].title][fld.title][tbcol.title])}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsYears"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td>{{fld.name}}</td>
                  <td v-for="tbcol in tableColsYears" v-bind:key="'yearcol'+tbcol.title">
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th class="text-bold">P10</th>
                  <th class></th>
                </tr>
              </thead>
              <tbody v-for="(fld, ind) in tableCols10" :key="'p10'+ind">
                <tr v-if="fld.type===1">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableCols"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===1">
                  <td class>{{fld.name}}</td>
                  <td class v-for="tbcol in tableCols" v-bind:key="'yearcol'+tbcol.title">
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tbcol.title][fld.title] === 0)? 'No': (rawData[actTab][tbcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
                <tr v-if="fld.type===2">
                  <td class>{{fld.name}}</td>
                  <td>
                    <!-- {{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tableCols[0].title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tableCols[0].title][fld.title]===0)? 'No': (rawData[actTab][tableCols[0].title][fld.title]===1)? 'Yes': -''}}</span>
                    <span v-else>{{rawData[actTab][tableCols[0].title][fld.title]}}</span>
                  </td>
                  <td :colspan="tableColsYears.length-1"></td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsAvg"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===3">
                  <td class>{{fld.name}}</td>
                  <td
                    v-for="(tbcol, ind) in tableColsAvg"
                    v-bind:key="'yearcol'+tbcol.title+ind"
                  >{{getChecknFixed(rawData[actTab][tableColsAvg[0].title][fld.title][tbcol.title])}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td class></td>
                  <td
                    class="text-bold"
                    v-for="tbcol in tableColsYears"
                    v-bind:key="'year'+tbcol.title"
                  >{{tbcol.name}}</td>
                </tr>
                <tr v-if="fld.type===4">
                  <td>{{fld.name}}</td>
                  <td v-for="tbcol in tableColsYears" v-bind:key="'yearcol'+tbcol.title">
                    <!-- {{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}} -->
                    <span
                      v-if="fld.dataType==='number'"
                    >{{getChecknFixed(rawData[actTab][tbcol.title][fld.title])}}</span>
                    <span
                      v-else-if="fld.dataType==='boolean'"
                    >{{(rawData[actTab][tblcol.title][fld.title] === 0)? 'No': (rawData[actTab][tblcol.title][fld.title] === 1)? 'Yes': '-'}}</span>
                    <span v-else>{{rawData[actTab][tbcol.title][fld.title]}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table :id="alg.name" class="table fonts11" v-if="actTab === 's1'">
              <!-- <tbody>
                  <tr v-for="(tbr, rind) in tableRows_s1" :key="'s1_'+rind">
                    <td class="text-bold">{{tbr.name}}</td>
                    <td :class="(rawData[actTab][tbr.title+'_color'])? 'f'+rawData[actTab][tbr.title+'_color']:''">
                      {{getChecknFixed(rawData[actTab][tbr.title])}}
                    </td>
                  </tr>
              </tbody>-->
              <thead>
                <tr>
                  <th></th>
                  <th v-for="(s1, thind) in tableCols_s1_a" :key="'s1a_'+thind">{{s1.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(s1c, trind) in tableRows_s1_a" :key="'s1a_col'+trind">
                  <td class="text-bold">{{s1c.name}}</td>
                  <td v-for="(s1, thind) in tableCols_s1_a" :key="'s1a_'+thind">
                    <!-- {{s1c.title+s1.title}} -->
                    {{(typeof rawData[actTab][s1.title+s1c.title] === 'number')? getFixed(rawData[actTab][s1.title+s1c.title]): getLabel(rawData[actTab][s1.title+s1c.title])}}
                  </td>
                </tr>
              </tbody>
              <br />
              <thead>
                <tr>
                  <th></th>
                  <th v-for="(s1, thind) in tableCols_s1_b" :key="s1.title+'s1b_'+thind">{{s1.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(s1c, trind) in tableRows_s1_b"
                  :key="'s1b_col'+trind"
                  :class="'f'+rawData[actTab][s1c.title+'color']"
                >
                  <td class="text-bold">{{s1c.name}}</td>
                  <td v-for="(s1, thind) in tableCols_s1_b" :key="'rows1b_'+thind">
                    <!-- {{s1c.title+s1.title}} -->
                    {{(typeof rawData[actTab][s1c.title+s1.title] === 'number')? getFixed(rawData[actTab][s1c.title+s1.title]): (rawData[actTab][s1c.title+s1.title])? getLabel(rawData[actTab][s1c.title+s1.title]): (rawData[actTab][s1c.title+s1.title])}}
                  </td>
                </tr>
                <tr
                  v-for="(s1c, trind) in tableRows2_s1_b"
                  :key="'s1b2_col'+trind"
                  :class="'f'+rawData[actTab][s1c.title+'color']"
                >
                  <td class="text-bold">{{s1c.name}}</td>
                  <td v-for="(s1, thind) in tableCols2_s1_b" :key="'row2s12b_'+thind">
                    <!-- {{s1c.title+s1.title}} -->
                    {{(typeof rawData[actTab][s1c.title+s1.title] === 'number')? getFixed(rawData[actTab][s1c.title+s1.title]): (rawData[actTab][s1c.title+s1.title])? getLabel(rawData[actTab][s1c.title+s1.title]): (rawData[actTab][s1c.title+s1.title])}}
                  </td>
                </tr>
              </tbody>
              <br />
              <br />
              <br />
              <tbody></tbody>
              <tbody v-for="(s1c, s1cind) in tableRows_s1_c" :key="'s1crow_'+s1cind">
                <tr>
                  <th colspan>{{s1c.name}}</th>
                  <th>Actual/Latest</th>
                  <th v-if="s1c.hasBenchmark">Benchmark</th>
                  <th v-if="s1c.avg">Avg</th>
                  <th v-if="s1c.avg">Valuation Trend</th>
                </tr>
                <tr
                  v-for="(sub, subInd) in s1c.subFields"
                  :key="'subrow_'+subInd"
                  v-if="!sub.isColor"
                >
                  <td>{{sub.name}}</td>
                  <td>
                    <span
                      v-if="sub.title==='latest_cyclical' || sub.title === 'latest_competative_advantage'"
                      :class="'f'+rawData[actTab][sub.color]"
                    >{{(rawData[actTab][sub.title] === 1)? 'Yes': (rawData[actTab][sub.title]===0)? 'No': '-'}}</span>
                    <span v-else>
                      <span v-if="sub.isNumeric && !sub.isColor">
                        <span
                          :class="(sub.hasColor)? 'f'+rawData[actTab][sub.color]: ''"
                        >{{getFixed(rawData[actTab][sub.title])}}</span>
                      </span>
                      <span
                        v-else-if="!sub.isColor"
                        :class="(sub.hasColor)? 'f'+rawData[actTab][sub.color]: ''"
                      >{{(rawData[actTab][sub.title])? getLabel(rawData[actTab][sub.title]): ''}}</span>
                    </span>
                  </td>
                  <td>
                    <span v-if="sub.benchmark">
                      <span
                        v-if="sub.title==='latest_total_taxes_paid'"
                      >{{rawData[actTab]['min_latest_total_taxes_paid_benchmark']}} - {{rawData[actTab]['max_latest_total_taxes_paid_benchmark']}}</span>
                      <span v-else>{{rawData[actTab][sub.benchmark]}}</span>
                    </span>
                  </td>
                  <td>
                    <span v-if="sub.avg">{{getFixed(rawData[actTab][sub.avg])}}</span>
                  </td>
                  <td>
                    <span v-if="sub.valuation">{{getLabel(rawData[actTab][sub.valuation])}}</span>
                  </td>
                </tr>
                <br />
                <br />
              </tbody>
            </table>
          </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import vtable from "@/components/vtable";
import spinner from "@/components/spinner";
import http from "@/lib/http";
import { commonMixins } from "@/assets/mixins/common.js";
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import StarRating from "vue-star-rating";
export default {
  components: { vtable, VueTabs, VTab, StarRating },
  // props: ["company"],
  mixins: [commonMixins],
  created() {
    // if (!this.company) this.$router.push({ name: "company" });
    console.log("API", this.rawDataApi);
    if (!localStorage.getItem("selcomp")) {
      if (!this.company) this.$router.push({ name: "company" });
    } else {
      this.company = JSON.parse(localStorage.getItem("selcomp"));
      this.getRawData();
    }
  },
  data() {
    return {
      tableFields: [],
      config: {
        rating: 2,
        style: {
          fullStarColor: "#ed8a19",
          emptyStarColor: "#737373",
          starWidth: 2,
          starHeight: 2
        }
      },
      rawDataApi: "formulas/",
      rawData: {},
      pTabs: [
        "p2",
        "p3",
        "p4",
        "p5_a",
        "p5_b",
        "p6_a",
        "p6_b",
        "p7_a",
        "p8_a",
        "p8_b",
        "p10",
        "quarterly_trends",
        "q1",
        "q1_a",
        "q1_b",
        "q1_c",
        "q1_d",
      ],
      removedTabs: [
        "co_code",
        "_id",
        "algo_1",
        "algo_2",
        "manual",
        "last_updated",
        "quarterly_trends",
        "q1_a_or_b",
        "sectorcode",
        "business_rating"
      ],
      activeTabs: [
        "p1",
        "p2",
        "p3",
        "p4",
        "p5_a",
        "p5_b",
        "p6_a",
        "p6_b",
        "p7_a",
        "p8_a",
        "p8_b",
        "p10",
        "p11",
        "quarterly_trends",
        "q1",
        "q1_a",
        "q1_b",
        "q1_a_or_b",
        "q1_c",
        "q1_d",
        "s1",
        "return_analysis",
        "return_one_analysis",
        "years"
      ],
      tabs: [],
      objectKeys: Object.keys,
      actTab: "",
      selTab: 0,
      selRowInd: 0,
      percentField: [],
      tableCols: [],
      //P1 1 yearly, 2 single, 3 average, 4 yearwise
      tableCols1: [
        {
          title: "eps_after_minority_interest_adj",
          name: this.getLabel("EPS"),
          type: 1,
          dataType: "number"
        },
        {
          title: "eps_growth_rate_minority_after",
          name: this.getLabel("eps_growth_rate_minority_after"),
          type: 1,
          dataType: "number"
        },
        {
          title: "eps_growth_rate_minority_before",
          name: this.getLabel("eps_growth_rate_minority_before"),
          type: 1,
          dataType: "number"
        },
        {
          title: "eps_growth_rate_minority_after",
          name: this.getLabel("eps_growth_rate_minority_after"),
          type: 3,
          dataType: "number"
        },
        {
          title: "eps_growth_rate_minority_before",
          name: this.getLabel("eps_growth_rate_minority_before"),
          type: 3,
          dataType: "number"
        },
        {
          title: "latest_price",
          name: this.getLabel("price"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "PEG",
          name: this.getLabel("PEG"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "net_sales",
          name: this.getLabel("sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "inventory",
          name: this.getLabel("inventory"),
          type: 1,
          dataType: "number"
        },
        {
          title: "inventory_by_sales",
          name: this.getLabel("inventory_by_sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "change_in_inventory_by_sales",
          name: this.getLabel("change_in_inventory_by_sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "earnings_yield",
          name: this.getLabel("earnings_yield"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "sensex_earnings_yield",
          name: this.getLabel("sensex_earnings_yield"),
          type: 2,
          dataType: "number"
        }, //Latest single
        {
          title: "current_long_term_treasury_yield",
          name: this.getLabel("current_long_term_treasury_yield"),
          type: 2,
          dataType: "number"
        }, //Latest single
        {
          title: "maximum_of_sensex_yield_and_treasury_yield",
          name: this.getLabel("maximum_of_sensex_yield_and_treasury_yield"),
          type: 2,
          dataType: "number"
        },
        {
          title: "dividend_yield",
          name: this.getLabel("dividend_yield"),
          type: 1,
          dataType: "number"
        }, //Yearly
        { title: "pe", name: this.getLabel("PE"), type: 1, dataType: "number" }, //Yearly
        {
          title: "total_debt_by_equity",
          name: this.getLabel("total_debt_by_equity"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "net_cash_accrual",
          name: this.getLabel("net_cash_accrual"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "net_cash_accrual_by_price",
          name: this.getLabel("net_cash_accrual_by_price"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "net_cash_accrual_per_share",
          name: this.getLabel("net_cash_accrual_per_share"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "net_cash_per_price",
          name: this.getLabel("net_cash_per_price"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "net_cash_per_share",
          name: this.getLabel("net_cash_per_share"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "equity_by_assets",
          name: this.getLabel("equity_by_assets"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "return_on_assets",
          name: this.getLabel("return_on_assets"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "is_it_a_financial_company",
          name: this.getLabel("is_it_a_financial_company"),
          type: 2,
          dataType: "string"
        }, //single
        {
          title: "is_it_a_medical_company",
          name: this.getLabel("is_it_a_medical_company"),
          type: 2,
          dataType: "string"
        }, //single
        {
          title: "is_it_a_service_company",
          name: this.getLabel("is_it_a_service_company"),
          type: 2,
          dataType: "string"
        }, //single
        {
          title: "is_it_a_technology_company",
          name: this.getLabel("is_it_a_technology_company"),
          type: 2,
          dataType: "string"
        }, //single
        {
          title: "is_it_a_utility/telecom/railroad_company",
          name: this.getLabel("is_it_a_utility/telecom/railroad_company"),
          type: 2,
          dataType: "string"
        } //single
      ],
      //P2
      tableCols2: [
        {
          title: "total_retained_eps_for_last_10_years",
          name: this.getLabel("total_retained_eps_for_last_10_years"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "retention_ratio",
          name: this.getLabel("retention_ratio"),
          type: 1,
          dataType: "number"
        }, //yearly
        // {
        //   title: "retention_ratio",
        //   name: this.getLabel("retention_ratio"),
        //   type: 2, dataType: 'number'
        // }, //single
        {
          title: "initial_rate_of_return",
          name: this.getLabel("initial_rate_of_return"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "analyst_consensus_eps_growth_estimate_for_long_term",
          name: this.getLabel(
            "estimated_long_term_earnings_growth_as_per_analysts_estimate"
          ),
          type: 2,
          dataType: "number"
        }, //single
        {
          title:
            "minimum_of_initial_rate_of_return_and_estimated_long_term_eps_growth_rate",
          name: this.getLabel(
            "minimum_of_initial_rate_of_return_and_estimated_long_term_eps_growth_rate"
          ),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "current_long_term_treasury_yield",
          name: this.getLabel("current_long_term_treasury_yield"),
          type: 2,
          dataType: "number"
        }, //Latest single
        {
          title: "sustainable_earnings_growth_rate",
          name: this.getLabel("sustainable_earnings_growth_rate"),
          type: 2,
          dataType: "number"
        }, //Latest single
        {
          title: "future_book_value_per_share_at_year_10",
          name: this.getLabel("future_book_value_per_share_at_year_10"),
          type: 2,
          dataType: "number"
        }, //Latest single
        {
          title: "expected_eps_at_year_10",
          name: this.getLabel("expected_eps_at_year_10"),
          type: 2,
          dataType: "number"
        }, //Latest single
        { title: "pe", name: this.getLabel("pe"), type: 1, dataType: "number" }, //Yearly
        {
          title: "average_pe_last_10_years",
          name: this.getLabel("average_pe_last_10_years"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "lower_of_avg_pe_and_latest_pe",
          name: this.getLabel("lower_of_avg_pe_and_latest_pe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "projected_price_at_year_10_based_on_avg_roe",
          name: this.getLabel("projected_price_at_year_10_based_on_avg_roe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "projected_earnings_based_on_historical_avg_eps_growth_rate",
          name: this.getLabel(
            "projected_earnings_based_on_historical_avg_eps_growth_rate"
          ),
          type: 4,
          dataType: "number"
        }, //10YEAR
        {
          title: "expected_dividend_per_share",
          name: this.getLabel("expected_dividend_per_share"),
          type: 4,
          dataType: "number"
        }, //10YEAR
        {
          title: "expected_return_based_on_avg_roe",
          name: this.getLabel("expected_return_based_on_avg_roe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "expected_rate_of_return_based_on_avg_roe",
          name: this.getLabel("expected_rate_of_return_based_on_avg_roe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "projected_eps_based_on_avg_eps_growth",
          name: this.getLabel("projected_eps_based_on_avg_eps_growth"),
          type: 4,
          dataType: "number"
        }, //10YEAR
        {
          title: "projected_dividend_per_share",
          name: this.getLabel("projected_dividend_per_share"),
          type: 4,
          dataType: "number"
        }, //10YEAR
        {
          title: "projected_price_at_year_10_based_on_avg_eps_growth",
          name: this.getLabel(
            "projected_price_at_year_10_based_on_avg_eps_growth"
          ),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "expected_return_based_on_avg_eps_growth",
          name: this.getLabel("expected_return_based_on_avg_eps_growth"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "expected_rate_of_return_based_on_avg_eps_growth",
          name: this.getLabel(
            "expected_rate_of_return_based_on_avg_eps_growth"
          ),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "avg_expected_rate_of_return",
          name: this.getLabel("avg_expected_rate_of_return"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "has_durable_competative_advantage",
          name: this.getLabel("has_durable_competative_advantage"),
          type: 2,
          dataType: "boolean"
        }, //single
        {
          title: "eps_after_minority_interest_adj",
          name: this.getLabel("eps_after_minority_interest_adj"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_before_minority_interest_adj",
          name: this.getLabel("eps_before_minority_interest_adj"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "min_eps_after_minority_adj_excluding_latest_year",
          name: this.getLabel(
            "min_eps_after_minority_adj_excluding_latest_year"
          ),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "change_in_eps",
          name: this.getLabel("change_in_eps"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "percentage_change_in_eps",
          name: this.getLabel("percentage_change_in_eps"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "years_with_negative_change_in_eps",
          name: this.getLabel("years_with_negative_change_in_eps"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "aggregate_percentage_decline_in_EPS_in_last_10_years",
          name: this.getLabel(
            "aggregate_percentage_decline_in_EPS_in_last_10_years"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_growth_rate_minority_after",
          name: this.getLabel("eps_growth_rate_minority_after"),
          type: 3,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_growth_rate_minority_before",
          name: this.getLabel("eps_growth_rate_minority_before"),
          type: 3
        }, //Yearly
        {
          title: "avg_historical_eps_growth_rate",
          name: this.getLabel("avg_historical_eps_growth_rate"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "long_term_debt_by_net_profit",
          name: this.getLabel("long_term_debt_by_net_profit"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "roe",
          name: this.getLabel("roe"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "average_roe",
          name: this.getLabel("average_roe"),
          type: 2,
          dataType: "number"
        }, //Yearly
        {
          title: "minimum_roe_excluding_latest_year",
          name: this.getLabel("minimum_roe_excluding_latest_year"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "avg_roe_of_last_3_years",
          name: this.getLabel("avg_roe_of_last_3_years"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "return_on_total_capital",
          name: this.getLabel("return_on_total_capital"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "min_return_on_total_capital_excluding_last_year",
          name: this.getLabel(
            "min_return_on_total_capital_excluding_last_year"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "avg_return_on_total_capital_excluding_last_year",
          name: this.getLabel(
            "avg_return_on_total_capital_excluding_last_year"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "free_cash_flow",
          name: this.getLabel("free_cash_flow"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "retained_capital_utilization",
          name: this.getLabel("retained_capital_utilization"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title:
            "latest_number_of_shares_outstanding_less_than_last_years_number_of_shares",
          name: this.getLabel("are_the_outstanding_shares_falling"),
          type: 2,
          dataType: "boolean"
        } //Single
      ],
      //P3
      tableCols3: [
        {
          title: "current_ratio",
          name: this.getLabel("current_ratio"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "pe_using_last_3_years_avg_earnings",
          name: this.getLabel("pe_using_last_3_years_avg_earnings"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "price_to_book",
          name: this.getLabel("price_to_book"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "net_sales",
          name: this.getLabel("sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "total_debt",
          name: this.getLabel("total_debt"),
          type: 1,
          dataType: "number",
          dataType: "number"
        }, //Yearly
        {
          title: "long_term_debt",
          name: this.getLabel("long_term_debt"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "net_worth",
          name: this.getLabel("net_worth"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "net_current_assets",
          name: this.getLabel("net_current_assets"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_after_minority_interest",
          name: this.getLabel("eps_minority_after"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_before_minority_interest",
          name: this.getLabel("eps_minority_before"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "min_eps_in_last_5_years",
          name: this.getLabel("min_eps_in_last_5_years"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_growth_of_year10_vs_year1",
          name: this.getLabel("eps_growth_of_year10_vs_year1"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "latest_price",
          name: this.getLabel("latest_price"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "latest_pe",
          name: this.getLabel("latest_pe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "min_pe_latest_vs_pe_using_last_3_years_avg",
          name: this.getLabel("min_pe_latest_vs_pe_using_last_3_years_avg"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "pb_multiply_by_pe",
          name: this.getLabel("pb_multiply_by_pe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "bvps",
          name: this.getLabel("bvps"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "is_it_a_technology_company",
          name: this.getLabel("is_it_a_technology_company"),
          type: 2,
          dataType: "string"
        }, //Single
        {
          title: "is_it_a_financial_company",
          name: this.getLabel("is_it_a_financial_company"),
          type: 2,
          dataType: "string"
        }, //Single
        {
          title: "min_eps_in_last_5_years",
          name: this.getLabel("min_eps_in_last_5_years"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "avg_eps_last_3_years",
          name: this.getLabel("avg_eps_last_3_years"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "avg_eps_first_3_years",
          name: this.getLabel("avg_eps_first_3_years"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "avg_eps_last_3_years_vs_avg_eps_1st_3_years_growth",
          name: this.getLabel(
            "avg_eps_last_3_years_vs_avg_eps_1st_3_years_growth"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "total_debt_by_equity",
          name: this.getLabel("total_debt_by_equity"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "long_term_debt_by_net_worth",
          name: this.getLabel("long_term_debt_by_net_worth"),
          type: 2,
          dataType: "number"
        } //Yearly
      ],
      //P4
      tableCols4: [
        {
          title: "latest_price",
          name: this.getLabel("latest_price"),
          type: 2,
          dataType: "number"
        }, //Yearly
        { title: "pe", name: this.getLabel("pe"), type: 1, dataType: "number" }, //Yearly
        {
          title: "avg_of_latest_pe_and_last_4_years",
          name: this.getLabel("avg_of_latest_pe_and_last_4_years"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title:
            "avg_of_latest_pe_and_last_4_years_per_bse_500_pe_avg_latest_5_years",
          name: this.getLabel(
            "avg_of_latest_pe_and_last_4_years_per_bse_500_pe_avg_latest_5_years"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_after_minority_interest",
          name: this.getLabel("eps_minority_after"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_before_minority_interest",
          name: this.getLabel("eps_minority_before"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_growth_rate_minority_after",
          name: this.getLabel("eps_growth_rate_minority_after"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_growth_rate_minority_before",
          name: this.getLabel("eps_growth_rate_minority_before"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_growth_rate_minority_after",
          name: this.getLabel("eps_growth_rate_minority_after"),
          type: 3,
          dataType: "number"
        }, //Average
        {
          title: "eps_growth_rate_minority_before",
          name: this.getLabel("eps_growth_rate_minority_before"),
          type: 3,
          dataType: "number"
        }, //Average
        {
          title: "analyst_consensus_eps_growth_estimate_of_current_year",
          name: this.getLabel(
            "analyst_consensus_eps_growth_estimate_of_current_year"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "analyst_consensus_eps_growth_estimate_for_long_term",
          name: this.getLabel(
            "analyst_consensus_eps_growth_estimate_for_long_term"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "net_sales",
          name: this.getLabel("net_sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "net_sales_growth_rate",
          name: this.getLabel("net_sales_growth_rate"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "avg_sales_growth",
          name: this.getLabel("avg_sales_growth"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "dividend_per_share",
          name: this.getLabel("dividend_per_share"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "dividend_yield",
          name: this.getLabel("dividend_yield"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "avg_dividend_yield",
          name: this.getLabel("avg_dividend_yield"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "total_return",
          name: this.getLabel("total_return"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "total_return_per_pe",
          name: this.getLabel("total_return_per_pe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "market_earnings",
          name: this.getLabel("market_earnings"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "market_earnings_growth",
          name: this.getLabel("market_earnings_growth"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "avg_bse_sensex_500_earnings_growth",
          name: this.getLabel("avg_bse_sensex_500_earnings_growth"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "bse_500",
          name: this.getLabel("bse_500"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "bse_500_dividend",
          name: this.getLabel("bse_500_dividend"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "markets_dividend_yield",
          name: this.getLabel("markets_dividend_yield"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "avg_bse_sensex_500_div_yield",
          name: this.getLabel("avg_bse_sensex_500_div_yield"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "total_market_return",
          name: this.getLabel("total_market_return"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "bse_500_pe",
          name: this.getLabel("bse_500_pe"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "bse_500_pe_avg_latest_5_years",
          name: this.getLabel("bse_500_pe_avg_latest_5_years"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "total_market_return_per_bse_500_pe_avg_latest_5_years",
          name: this.getLabel(
            "total_market_return_per_bse_500_pe_avg_latest_5_years"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "industry_earning",
          name: this.getLabel("industry_earning"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "industry_earning_growth",
          name: this.getLabel("industries_earning_growth"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "avg_industry_earning_growth",
          name: this.getLabel("avg_industry_earning_growth"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "industry_index",
          name: this.getLabel("industry_index"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "industry_dividend",
          name: this.getLabel("industry_dividend"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "industry_dividend_yield",
          name: this.getLabel("industry_dividend_yield"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "avg_industry_dividend_yield",
          name: this.getLabel("avg_industry_dividend_yield"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "industry_total_return",
          name: this.getLabel("industry_total_return"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "industry_pe",
          name: this.getLabel("industry_pe"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "avg_industry_pe",
          name: this.getLabel("avg_industry_pe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "industry_total_return_by_avg_industry_pe",
          name: this.getLabel("industry_total_return_by_avg_industry_pe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "free_cash_flow",
          name: this.getLabel("free_cash_flow"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_of_L_qtr_minus_eps_of_L-1_qtr",
          name: this.getLabel("eps_of_L_qtr_minus_eps_of_L-1_qtr"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_of_L_qtr_minus_eps_of_L-1_qtr",
          name: this.getLabel("eps_of_L_qtr_minus_eps_of_L-1_qtr"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_of_L_qtr_minus_eps_of_L-1_qtr",
          name: this.getLabel("eps_of_L_qtr_minus_eps_of_L-1_qtr"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "min_eps_diff",
          name: this.getLabel("min_eps_diff"),
          type: 2,
          dataType: "number"
        } //Single
      ],
      //P5
      tableCols5: [
        {
          title: "price",
          name: this.getLabel("price"),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "eps_after_minority_interest",
          name: this.getLabel("eps_minority_after"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_before_minority_interest",
          name: this.getLabel("eps_minority_before"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "net_cash_accrual_per_share",
          name: this.getLabel("net_cash_accrual_per_share"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "bvps",
          name: this.getLabel("bvps"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "dividend_per_share",
          name: this.getLabel("dividend_per_share"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "pe_ratio",
          name: this.getLabel("pe_ratio"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "pb_ratio",
          name: this.getLabel("pb_ratio"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "pcf_ratio",
          name: this.getLabel("pcf_ratio"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "pdividend_ratio",
          name: this.getLabel("pdividend_ratio"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "cut_off_pe_ratio",
          name: this.getLabel("cut_off_pe_ratio"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "cut_off_pb_ratio",
          name: this.getLabel("cut_off_pb_ratio"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "cut_off_pcf_ratio",
          name: this.getLabel("cut_off_pcf_ratio"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "cut_off_pdividend_ratio",
          name: this.getLabel("cut_off_pdividend_ratio"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "is_the_stock_amount_1500_largest_publicly_traded_stock",
          name: this.getLabel(
            "is_the_stock_amount_1500_largest_publicly_traded_stock"
          ),
          type: 2,
          dataType: "boolean"
        }, //single
        {
          title: "latest_qtr_eps_minus_prev_qtr_eps",
          name: this.getLabel("latest_qtr_eps_minus_prev_qtr_eps"),
          type: 2,
          dataType: "number"
        }, //single
        {
          title: "market_earnings",
          name: this.getLabel("market_earnings"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "earnings_growth_rate(L - L-2)_qtrly",
          name: this.getLabel("earnings_growth_rate(L - L-2)_qtrly"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "projected_earnings_growth_of_sensex_this_year",
          name: this.getLabel("projected_earnings_growth_of_sensex_this_year"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "analyst_consensus_eps_growth_estimate_of_current_year",
          name: this.getLabel(
            "analyst_consensus_eps_growth_estimate_of_the_year_following_the_current_year"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title:
            "projected_earnings_growth_of_sensex_of_the_year_following_the_current_year",
          name: this.getLabel(
            "projected_earnings_growth_of_sensex_of_the_year_following_the_current_year"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_of_the_qrtr_before_the_earnings_dip",
          name: this.getLabel("eps_of_the_qrtr_before_the_earnings_dip"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "projected_quartery_eps_for_current_quarter",
          name: this.getLabel("projected_qrtly_eps_for_current_qrtr"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title:
            "projected_quartery_eps_for_the_quarter_following_the_current_quarter",
          name: this.getLabel(
            "projected_qrtly_eps_for_the_qrtr_following_the_current_qrtr"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "max_of_P1_and_P2",
          name: this.getLabel("max_of_P1_and_P2"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "industry_current_ratio",
          name: this.getLabel("industry_current_ratio"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "current_ratio",
          name: this.getLabel("current_ratio"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "dividend_payout_ratio",
          name: this.getLabel("dividend_payout_ratio"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "dividend_payout_ratio_avg",
          name: this.getLabel("dividend_payout_ratio_avg"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "roe_of_the_500th_stock",
          name: this.getLabel("roe_of_the_500th_stock"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "roe",
          name: this.getLabel("roe"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "pbt_by_net_sales",
          name: this.getLabel("pbt_by_net_sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "dividend_yield",
          name: this.getLabel("dividend_yield"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "sensex_dividend_yield",
          name: this.getLabel("sensex_dividend_yield"),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "avg_bse_sensex_500_div_yield",
          name: this.getLabel("avg_bse_sensex_500_div_yield"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "total_debt_by_equity",
          name: this.getLabel("total_debt_by_equity"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "industry_avg_debt_equity",
          name: this.getLabel("industry_avg_debt_equity"),
          type: 2,
          dataType: "number"
        } //Single
      ],
      //P6
      tableCols6: [
        {
          title: "is_it_a_cyclical_stock",
          name: this.getLabel("is_it_a_cyclical_stock"),
          type: 2,
          dataType: "boolean"
        }, //Single
        {
          title: "p_per_sales",
          name: this.getLabel("p_per_sales"),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "total_debt_by_equity",
          name: this.getLabel("total_debt_by_equity"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "is_it_a_technology_company",
          name: this.getLabel("is_it_a_technology_company"),
          type: 2,
          dataType: "string"
        }, //Single
        {
          title: "is_it_a_medical_company",
          name: this.getLabel("is_it_a_medical_company"),
          type: 2,
          dataType: "string"
        }, //Single
        {
          title: "research_development_costs",
          name: this.getLabel("research_development_costs"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "market_cap_by_research_and_development_cost",
          name: this.getLabel("market_cap_by_research_and_development_cost"),
          type: 2,
          dataType: "number"
        }, //Yearly
        {
          title: "inflation",
          name: this.getLabel("inflation"),
          type: 2,
          dataType: "number"
        }, //Latest
        {
          title: "eps_growth_rate_minority_after",
          name: this.getLabel("eps_growth_rate_minority_after"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_growth_rate_minority_after",
          name: this.getLabel("eps_growth_rate_minority_after"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "inflation_adjusted_eps_growth",
          name: this.getLabel("inflation_adjusted_eps_growth"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "free_cash_flow_per_share",
          name: this.getLabel("free_cash_flow_per_share"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "pbt",
          name: this.getLabel("pbt"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "net_sales",
          name: this.getLabel("net_sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "pbt_by_net_sales",
          name: this.getLabel("pbt_by_net_sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "pbt_by_sales_avg_3_years",
          name: this.getLabel("pbt_by_sales_avg_3_years"),
          type: 2,
          dataType: "number"
        } //Single
      ],
      //P7
      tableCols7: [
        {
          title: "change_in_discount_rate",
          name: this.getLabel("change_in_discount_rate"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "change_in_reserve_requirement",
          name: this.getLabel("change_in_reserve_requirement"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "change_in_repo_rate",
          name: this.getLabel("change_in_repo_rate"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "max_change_in_discount_rate_or_reserve_requirement",
          name: this.getLabel(
            "max_change_in_discount_rate_or_reserve_requirement"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "change_in_gdp_growth",
          name: this.getLabel("change_in_gdp_growth"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "change_in_installment_debt",
          name: this.getLabel("change_in_installment_debt"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "prime_rate_or_base_rate_latest",
          name: this.getLabel("prime_rate_or_base_rate_latest"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "change_in_prime_rate_or_base_rate_during_last_2_qrtr",
          name: this.getLabel(
            "change_in_prime_rate_or_base_rate_during_last_2_qrtr"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title:
            "change_in_prime_rate_or_base_rate_during_2_qrtrs_prev_last_2_qrtr",
          name: this.getLabel(
            "change_in_prime_rate_or_base_rate_during_2_qrtrs_prev_last_2_qrtr"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "latest_pe",
          name: this.getLabel("latest_pe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "market_pe_latest",
          name: this.getLabel("market_pe_latest"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "three_times_market_pe",
          name: this.getLabel("three_times_market_pe"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "min_of_three_times_market_pe_43",
          name: this.getLabel("min_of_three_times_market_pe_43"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "net_sales",
          name: this.getLabel("net_sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "net_sales_growth",
          name: this.getLabel("net_sales_growth"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "avg_sales_growth",
          name: this.getLabel("avg_sales_growth"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_after_minority_interest_adj",
          name: this.getLabel("eps"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_growth_rate_minority_after",
          name: this.getLabel("eps_growth_rate_minority_after"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_growth_rate_minority_before",
          name: this.getLabel("eps_growth_rate_minority_before"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_growth_rate_minority_after",
          name: this.getLabel("eps_growth_rate_minority_after"),
          type: 3,
          dataType: "number"
        }, //AVG
        {
          title: "eps_growth_rate_minority_before",
          name: this.getLabel("eps_growth_rate_minority_before"),
          type: 3,
          dataType: "number"
        }, //AVG
        {
          title: "avg_sales_growth_by_eps_growth",
          name: this.getLabel("avg_sales_growth_by_eps_growth"),
          type: 2,
          dataType: "number"
        }, //Single
        //Sales last 8 qrtr figures
        {
          title: "net_sales",
          name: this.getLabel("net_sales"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "sales_growth_last_qrtr_yoy",
          name: this.getLabel("sales_growth_last_qrtr_yoy"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "sales_growth_l-1_yoy",
          name: this.getLabel("sales_growth_l-1_yoy"),
          type: 2,
          dataType: "number"
        }, //Single

        //EPS last 8 qrtr figures
        {
          title: "eps_after_minority_interest_adj",
          name: this.getLabel("eps"),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title:
            "eps_growth_latest_qrtr_minus_eps_growth_of_the_same_qrtr_last_year",
          name: this.getLabel(
            "eps_growth_latest_qrtr_minus_eps_growth_of_the_same_qrtr_last_year"
          ),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_growth_latest_qrtr_yoy",
          name: this.getLabel("eps_growth_latest_qrtr_yoy"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_growth_l-1_yoy",
          name: this.getLabel("eps_growth_l-1_yoy"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_growth_l-2_yoy",
          name: this.getLabel("eps_growth_l-2_yoy"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "eps_growth_l-3_yoy",
          name: this.getLabel("eps_growth_l-3_yoy"),
          type: 2
        }, //Single
        {
          title: "min_growth_in_qrtr_eps_of_last_8_qrtr",
          name: this.getLabel("min_growth_in_qrtr_eps_of_last_8_qrtr"),
          type: 2,
          dataType: "number"
        }, //Single

        {
          title: "eps_growth_rate_minority_after",
          name: this.getLabel("eps_growth_rate_minority_after"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_growth_rate_minority_before",
          name: this.getLabel("eps_growth_rate_minority_before"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "change_in_eps",
          name: this.getLabel("change_in_eps"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "min_change_in_eps",
          name: this.getLabel("min_change_in_eps"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "avg_percent_growth_in_last_8_qrtrs",
          name: this.getLabel("avg_percent_growth_in_last_8_qrtrs"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "industry_avg_debt_equity",
          name: this.getLabel("industry_avg_debt_equity"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "total_debt_by_equity",
          name: this.getLabel("total_debt_by_equity"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "insiders_sell_transactions",
          name: this.getLabel("insiders_sell_transactions"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "insiders_buy_transactions",
          name: this.getLabel("insiders_buy_transactions"),
          type: 2,
          dataType: "number"
        } //Single
      ],
      //P8
      tableCols8: [
        {
          title: "latest_market_cap",
          name: this.getLabel("latest_market_cap"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "net_profit",
          name: this.getLabel("net_profit"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "other_income",
          name: this.getLabel("other_income"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "extraordinary_profit_or_loss",
          name: this.getLabel("extraordinary_profit_or_loss"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "net_profit_after_extraordinary_profit_or_loss",
          name: this.getLabel("net_profit_after_extraordinary_profit_or_loss"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "number_of_shares_outstanding",
          name: this.getLabel("number_of_shares_outstanding"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "eps_before_extraordinary_items",
          name: this.getLabel("eps_before_extraordinary_items"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "min_change_in_eps_before_extraordinary_items",
          name: this.getLabel("min_change_in_eps_before_extraordinary_items"),
          type: 2,
          dataType: "number"
        }, //Yearly
        {
          title: "net_sales",
          name: this.getLabel("net_sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "price_to_sales",
          name: this.getLabel("price_to_sales"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "relative_strength_ranking",
          name: this.getLabel("relative_strength_ranking"),
          type: 2,
          dataType: "boolean"
        }, //Yearly
        {
          title: "net_cash_from_operating_activities",
          name: this.getLabel("net_cash_from_operating_activities"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "market_avg_cash_from_operating_activities",
          name: this.getLabel("market_avg_cash_from_operating_activities"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "market_avg_shares_outstanding",
          name: this.getLabel("market_avg_shares_outstanding"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "market_avg_market_cap",
          name: this.getLabel("market_avg_market_cap"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "sales_during_trailling_12_months",
          name: this.getLabel("sales_during_trailling_12_months"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "market_avg_sales_during_trailling_12_months",
          name: this.getLabel("market_avg_sales_during_trailling_12_months"),
          type: 2,
          dataType: "number"
        }, //Yearly
        {
          title: "relative_strength_measure",
          name: this.getLabel("relative_strength_measure"),
          type: 2,
          dataType: "boolean"
        } //Single
      ],
      //P9
      tableCols9: [
        {
          title: "market_cap_largest_among_3500_companies",
          name: this.getLabel("market_cap_largest_among_3500_companies"),
          type: 2,
          dataType: "boolean"
        }, //Single
        {
          title: "ebit",
          name: this.getLabel("ebit"),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "current_assets",
          name: this.getLabel("current_assets(Excluding excess cash)"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "current_liabilities",
          name: this.getLabel(
            "current_liabilities(Excluding short term interest bearing debt)"
          ),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "net_current_assets",
          name: this.getLabel("net_current_assets"),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "net_fixed_assets",
          name: this.getLabel("net_fixed_assets"),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "preferred_equity",
          name: this.getLabel("preferred_equity"),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "enterprise_value",
          name: this.getLabel("enterprise_value"),
          type: 2,
          dataType: "number"
        } //Single
      ],
      //P10
      tableCols10: [
        {
          title: "book_market_ratio",
          name: this.getLabel("book_market_ratio"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "book_market_ratio_cut_off_of_top_20%_of_market",
          name: this.getLabel("book_market_ratio_cut_off_of_top_20%_of_market"),
          type: 2,
          dataType: "number"
        }, //Single
        {
          title: "return_on_assets",
          name: this.getLabel("return_on_assets"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title:
            "return_on_assets_of_latest_year_minus_return_on_assets_of_prev_year",
          name: this.getLabel(
            "return_on_assets_of_latest_year_minus_return_on_assets_of_prev_year"
          ),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "net_cash_from_operating_activities",
          name: this.getLabel("net_cash_from_operating_activities"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "net_cash_from_operating_activities_minus_net_profit",
          name: this.getLabel(
            "net_cash_from_operating_activities_minus_net_profit"
          ),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "long_term_debt_by_assets",
          name: this.getLabel("long_term_debt_by_assets"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title:
            "long_term_debt_by_assets_of_prev_year_minus_long_term_debt_by_assets_latest_year",
          name: this.getLabel(
            "long_term_debt_by_assets_of_prev_year_minus_long_term_debt_by_assets_latest_year"
          ),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "current_ratio",
          name: this.getLabel("current_ratio"),
          type: 1,
          dataType: "number",
          dataType: "number"
        }, //Yearly
        {
          title: "current_ratio_latest_year_minus_current_ratio_prev_year",
          name: this.getLabel(
            "current_ratio_latest_year_minus_current_ratio_prev_year"
          ),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "number_of_shares_outstanding",
          name: this.getLabel("number_of_shares_outstanding"),
          type: 1,
          dataType: "number",
          dataType: "number"
        }, //Yearly
        {
          title:
            "latest_number_of_shares_outstanding_less_than_last_years_number_of_shares",
          name: this.getLabel(
            "latest_number_of_shares_outstanding_less_than_last_years_number_of_shares"
          ),
          type: 2,
          dataType: "boolean"
        }, //Single
        {
          title: "gross_margin",
          name: this.getLabel("gross_margin"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "gross_margin_of_latest_year_minus_gross_margin_of_prev_year",
          name: this.getLabel(
            "gross_margin_of_latest_year_minus_gross_margin_of_prev_year"
          ),
          type: 1,
          dataType: "number"
        }, //Single
        {
          title: "asset_turnover_ratio",
          name: this.getLabel("asset_turnover_ratio"),
          type: 1,
          dataType: "number"
        }, //Yearly
        {
          title: "asset_turnover_latest_minus_asset_turnover_prev_year",
          name: this.getLabel(
            "asset_turnover_latest_minus_asset_turnover_prev_year"
          ),
          type: 1,
          dataType: "number"
        } //Yearly
      ],
      tableRows: [],
      tableColsYears: [],
      tableRowsYears: [],
      tableColsAvg: [],
      tableRowsAvg1: [
        { title: "eps_growth_rate_minority_after", name: "" },
        { title: "eps_growth_rate_minority_before", name: "" }
      ],
      tableRowsAvg: [],
      tableFieldsRaw: [],
      tableColsP: [],
      tableRows_p1: [
        {
          title: "For all Companies",
          name: this.getLabel("For All Companies"),
          hasSubFields: 1,
          subFields: [
            { title: "PEG", name: "PEG" },
            {
              title: "increase_in_inventory_by_sales",
              name: this.getLabel("increase_in_inventory_by_sales")
            },
            {
              title: "total_debt_by_equity",
              name: this.getLabel("total_debt_by_equity")
            }
          ]
        },
        {
          title: "For Fast Growers",
          name: this.getLabel("For Fast Growers"),
          hasSubFields: 1,
          subFields: [
            { title: "fast_grower_sales", name: this.getLabel("Sales") },
            {
              title: "fast_grower_eps_growth",
              name: this.getLabel("EPS_growth")
            }
          ]
        },
        {
          title: "For Stalwart",
          name: this.getLabel("For Stalwart"),
          hasSubFields: 1,
          subFields: [
            { title: "stalwart_sales", name: this.getLabel("Sales") },
            { title: "stalwart_eps", name: this.getLabel("eps") }
          ]
        },
        {
          title: "Earnings Accelerations",
          name: this.getLabel("Earnings Accelerations"),
          hasSubFields: 1,
          subFields: [
            { title: "slow_grower_sales", name: this.getLabel("Sales") },
            {
              title: "slow_grower_earnings_yield",
              name: this.getLabel("Earning Yield")
            }
          ]
        },
        {
          title: "For financial companies only",
          name: this.getLabel("For financial companies only"),
          hasSubFields: 1,
          subFields: [
            {
              title: "equity_by_assets",
              name: this.getLabel("equity_by_assets")
            },
            {
              title: "return_on_assets",
              name: this.getLabel("return_on_assets")
            }
          ]
        }
      ],
      tableRows_p2: [
        "ROTC",
        "avg_ROTC",
        "avg_rate_of_return",
        "avg_roe",
        "does_the_company_have_competitive_advantage",
        "does_the_company_have_stable_earnings",
        "free_cash_flow",
        "long_term_debt_by_earnings",
        "no_negative_earnings",
        "outstanding_shares",
        "rate_of_return",
        "retained_earnings",
        "roe"
      ],
      tableRows_p3: [
        "avg_eps_last_3_years_vs_1st_3_years",
        "current_ratio",
        "eps",
        "long_term_debt_by_equity",
        "long_term_debt_less_than_net_current_assets",
        "min_pe_latest_vs_pe_using_last_3_years_avg",
        "pb_multiply_by_pe",
        "sales",
        "total_debt_by_net_worth"
      ],
      tableRows_p4: [
        "analysts_consesus_eps_growth_estimate_for_long_term",
        "analysts_consesus_eps_growth_estimate_of_current_year",
        "eps_growth",
        "free_cash_flow",
        "increase_quarterly_eps_of_last_four_quarts_yoy",
        "net_sales_growth",
        "net_sales_growth_by_eps_growth",
        "pe_ratio",
        "total_return_by_pe_ratio_per_total_industry_return_by_industry_pe",
        "total_return_by_pe_ratio_per_total_market_return_by_market_pe"
      ],
      tableRows_q1: [
        "PEG",
        "avg_rate_of_return",
        "ev_by_ebitda",
        "initial_rate_of_return",
        "intrinsic_value",
        "min_pe_latest_vs_pe_using_last_3_years_avg",
        "pb_multiply_by_pe",
        "pe_by_iv_buffet_avg_pe",
        "pe_by_iv_buffet_current_pe",
        "pe_by_iv_buffet_min_pe",
        "price_to_sales"
      ],
      tableRows_q1_a: [
        "ebit_by_ev",
        "ev_by_ebitda",
        "initial_rate_of_return",
        "intrinsic_value",
        "min_pe_latest_vs_pe_using_last_3_years_avg",
        "p_by_b",
        "p_by_cf",
        "pb_multiply_by_pe",
        "price_to_sales"
      ],
      tableRows_q1_b: [
        "PEG",
        "pe_by_iv_buffet_avg_pe",
        "pe_by_iv_buffet_current_pe",
        "pe_by_iv_buffet_min_pe"
      ],
      tableRows_q1_c: [
        "avg_rate_of_return",
        "return_analysis_avg",
        "return_analysis_min"
      ],
      tableRows_q1_d: ["avg_dividend_yield", "dividend_yield"],
      tableRows_p5_a: [
        "cut_off_pb_ratio_bottom_20_percent_of_the_market",
        "cut_off_pcf_ratio_bottom_20_percent_of_the_market",
        "cut_off_pdiv_ratio_bottom_20_percent_of_the_market",
        "cut_off_pe_ratio_bottom_20_percent_of_the_market"
      ],
      tableRows_p5_b: [
        "company_roe",
        "current_ratio",
        "debt_equity",
        "dividend_payout_ratio",
        "dividend_yield",
        "eps_growth_minus_earning_growth_of_sensex",
        "eps_of_last_quarter_minus_eps_of_the_quarter_before_dip",
        "latest_qtr_eps_minus_prev_qtr_eps",
        "pbt_per_sales",
        "projected_earning_growth_of_current_year_minus_projected_earning_growth_sensex_earning_current_year",
        "projected_earning_growth_of_year_following_current_year_minus_projected_earning_growth_sensex_earning_current_year",
        "stock_among_1500_largest_publicly_traded_stocks"
      ],
      tableRows_p6_a: [
        "is_it_a_cyclical_stock",
        "market_cap_by_research_and_development_cost",
        "price_to_sales_ratio_for_cyclical",
        "price_to_sales_ratio_for_non_cyclical_and_technology",
        "total_debt_by_equity"
      ],
      tableRows_p6_b: [
        "is_it_a_cyclical_stock",
        "free_cash_flow_per_share",
        "inflation_adjusted_eps_growth",
        "pbt_by_sales_average_3_years",
        "price_to_sales_ratio_for_cyclical",
        "price_to_sales_ratio_for_non_cyclical_and_technology"
      ],
      tableRows_p7_a: [
        "bearish_trend",
        "bullish_trend",
        "change_in_discount_rate",
        "change_in_gdp_growth",
        "change_in_installment_debt",
        "change_in_prime_rate",
        "change_in_prime_rate_II",
        "change_in_prime_rate_X",
        "change_in_prime_rate_q2_vs_q4",
        "maximum_change_in_prime_rate",
        "maximum_change_in_prime_rate_X",
        "prime_rate",
        "prime_rate_X"
      ],
      tableRows_p7_b: [
        {
          title: "",
          name: this.getLabel(""),
          hasSubFields: 1,
          subFields: [
            { title: "pe_ratio", name: this.getLabel("pe_ratio") },
            {
              title: "sales_growth(latest_qtr_vs_prev_qtr)",
              name: this.getLabel("sales_growth (latest_qtr_vs_prev_qtr)")
            },
            {
              title: "sales_growth(min_of_85%_of_eps_growth_or_30%",
              name: this.getLabel(
                "sales_growth (min_of_85%_of_eps_growth_or_30%)"
              )
            },
            {
              title: "sales_growth(min_of_85%_of_eps_growth_or_30%_X",
              name: this.getLabel(
                "sales_growth (min_of_85%_of_eps_growth_or_30%"
              )
            }
          ]
        },
        {
          title: "Trend of Earnings",
          name: this.getLabel("Trend of Earnings"),
          hasSubFields: 1,
          subFields: [
            {
              title: "current_quarterly_earnings",
              name: this.getLabel("current_quarterly_earnings")
            },
            {
              title: "quarterly_earnings_1_year_ago",
              name: this.getLabel("quarterly_earnings_1_year_ago")
            },
            {
              title: "positive_earnings_growth_in_current_qtr_YoY",
              name: this.getLabel("positive_earnings_growth_in_current_qtr_YoY")
            }
          ]
        },
        {
          title: "Earning Persistence",
          name: this.getLabel("Earning Persistence"),
          hasSubFields: 1,
          subFields: [
            {
              title: "annual_earnings_persistence",
              name: this.getLabel("annual_earnings_persistence")
            },
            {
              title: "earnings_growth_for_past_8_qtrs",
              name: this.getLabel("earnings_growth_for_past_8_qtrs")
            },
            {
              title: "long_term_eps_growth",
              name: this.getLabel("long_term_eps_growth")
            }
          ]
        },
        {
          title: "Earnings Accelerations",
          name: this.getLabel("Earnings Accelerations"),
          hasSubFields: 1,
          subFields: [
            {
              title: "%_eps_growth_latest_qtr_YoY",
              name: this.getLabel("%_eps_growth_latest_qtr_YoY")
            },
            {
              title: "%_eps_growth_YoY_greater_than_or_equal_to_avg_%_growth",
              name: this.getLabel(
                "%_eps_growth_YoY_greater_than_or_equal_to_avg_%_growth"
              )
            },
            {
              title: "slow_grower_earnings_yield",
              name: this.getLabel("Earning Yield")
            }
          ]
        },
        {
          title: "",
          name: this.getLabel(""),
          hasSubFields: 1,
          subFields: [
            {
              title: "total_debt_by_equity",
              name: this.getLabel("total_debt_by_equity")
            },
            {
              title: "insider_transactions",
              name: this.getLabel("insider_transactions")
            },
            {
              title: "insider_sell_transactions",
              name: this.getLabel("insider_sell_transactions")
            },
            {
              title: "insider_buy_transactions",
              name: this.getLabel("insider_buy_transactions")
            }
          ]
        }
      ],
      tableRows_p8_a: [
        "eps_persistence",
        "market_cap",
        "price_to_sales_ratio",
        "relative_strength_ranking"
        // "relative_strength_measure"
      ],
      tableRows_p8_b: [
        "cash_flow_per_share_greater_than_market_avg_cash_flow",
        "market_cap",
        "market_cap_greater_than_avg_market_cap",
        "number_of_shares_outstanding",
        // "relative_strength_ranking",
        "relative_strength_measure",
        "sales_during_trailing_12_months"
      ],
      tableRows_p10: [
        "asset_turnover_of_latest_vs_prev_year",
        "book_market_ratio",
        "cash_flow_from_operations",
        "cash_flow_from_operations_vs_net_profit",
        "current_ratio_of_latest_vs_prev_year",
        "gross_margin_of_latest_vs_prev_year",
        // "long_term_debt_by_assets_of_latest_vs_prev_year",
        // "total_debt_by_assets_of_latest_vs_prev_year",
        "number_of_outstanding_shares_latest_vs_prev_year",
        "roa",
        "roa_of_latest_year_vs_prev_year"
      ],
      tableP9Rows: [],
      tableP9Cols: [],
      tableP11Rows: [],
      tableQtrTrendsRows: [
        "increase_quarterly_eps_of_last_four_quarts_yoy",
        "latest_qtr_eps_minus_prev_qtr_eps",
        "eps_of_last_quarter_minus_eps_of_the_quarter_before_dip",
        "sales_growth(latest_qtr_vs_prev_qtr)",
        "current_quarterly_earnings",
        "quarterly_earnings_1_year_ago",
        "positive_earnings_growth_in_current_qtr_YoY",
        "%_eps_growth_YoY_greater_than_or_equal_to_avg_%_growth",
        "%_eps_growth_latest_qtr_YoY",
      ],
      tableP11Cols: [],
      tableRowsP11: [],
      tableRowsRA1: [
        { title: "at_average_pe", name: "IRR (at average PE)" },
        { title: "at_current_pe", name: "IRR (at current PE)" },
        { title: "at_highest_pe", name: "IRR (at highest PE)" },
        { title: "at_lowest_pe", name: "IRR (at lowest PE)" }
      ],
      tableRowsRA3: [
        { title: "average_roe", name: "Average ROE" },
        { title: "book_value_per_share_(latest)", name: "BVPS (Latest)" },
        { title: "eps_(latest)", name: "EPS (Latest)" },
        { title: "average_retention_ratio", name: "Average retention ratio" },
        { title: "sustainable_growth_rate", name: "Sustainable growth rate" },
        {
          title: "current_price_per_share",
          name: "Current price per share (INR)"
        },
        {
          title: "average_historical_eps_growth_rate_last_10_years",
          name: "Average historical EPS growth rate - last 10 years"
        },
        {
          title: "average_historical_eps_growth_rate_last_5_years",
          name: "Average historical EPS growth rate - last 5 years"
        },
        {
          title: "estimated_long_term_growth_rate_(eps)",
          name: "Estimated long term EPS growth rate (%)"
        }
      ],
      tableRowsRA4: [
        { title: "bvps_after_10_years", name: "BVPS after 10 years" },
        {
          title: "eps_after_10_years_at_sustainable_growth_rate",
          name: "EPS after 10 years (at sustainable growth rate)"
        },
        {
          title: "lower_of_avg_pe_and_latest_pe",
          name: "Lower of avg PE of last 10 years or Current PE"
        },
        {
          title: "projected_price_per_share_after_10_years",
          name: "Projected price per share after 10 years"
        }
      ],
      tableRowsRA5: [
        {
          title: "eps_after_10_years_at_estimated_growth_rate",
          name: "EPS after 10 years (at estimated growth rate)"
        },
        {
          title:
            "projected_price_per_share_after_10_years_at_estimated_growth_rate",
          name:
            "Projected price per share after 10 years (at estimated growth rate)"
        }
      ],
      tableRowsRA2: [
        {
          title:
            "avg_historical_growth_rate_5_years_at_lower_of_avg_pe_and_latest_pe",
          name:
            "Avg historical growth rate 5 Yrs (at lowest avg PE and Latest PE)"
        },
        {
          title:
            "avg_historical_growth_rate_9_years_at_lower_of_avg_pe_and_latest_pe",
          name:
            "Avg historical growth rate 9 Yrs (at lowest avg PE and Latest PE)"
        },
        {
          title: "estimated_long_term_eps_growth",
          name: "Estimated long term EPS Growth"
        }
      ],
      tableRowsRAFinal: [
        { title: "at_average_pe", name: "IRR (at average PE)" },
        { title: "at_current_pe", name: "IRR (at current PE)" },
        { title: "at_highest_pe", name: "IRR (at highest PE)" },
        { title: "at_lowest_pe", name: "IRR (at lowest PE)" },
        {
          title:
            "avg_historical_growth_rate_5_years_at_lower_of_avg_pe_and_latest_pe",
          name:
            "Avg historical growth rate 5 Yrs (at lowest avg PE and Latest PE)"
        },
        {
          title:
            "avg_historical_growth_rate_9_years_at_lower_of_avg_pe_and_latest_pe",
          name:
            "Avg historical growth rate 9 Yrs (at lowest avg PE and Latest PE)"
        },
        {
          title: "estimated_long_term_eps_growth",
          name: "Estimated long term EPS Growth"
        },
        {
          title: "avg",
          name: "Avg"
        }
      ],
      tableRowsRASubRow: [
        { title: "outflow_mkt_cap", name: "Outflow - mkt cap" },
        { title: "inflow_dividend", name: "Inflow Dividend" },
        { title: "net_cash_flow", name: "Net cashflows" },
        { title: "irr", name: "" }
      ],
      tableRows_s1: [],
      tableCols_s1_a: [
        { title: "benchmark_", name: this.getLabel("benchmark_") },
        { title: "avg_", name: this.getLabel("avg") },
        { title: "latest_", name: this.getLabel("latest_") },
        { title: "valuation_trends_", name: this.getLabel("valuation_trends_") }
      ],
      tableRows_s1_a: [
        { title: "ebit_per_ev", name: this.getLabel("ebit_per_ev") },
        { title: "ev_per_ebitda", name: this.getLabel("ev_per_ebitda") },
        // {title: "free_cash_flow", name: this.getLabel('free_cash_flow')},
        { title: "p_per_s", name: this.getLabel("p_per_s") },
        { title: "pb_ratio", name: this.getLabel("pb_ratio") },
        { title: "pcf_ratio", name: this.getLabel("pcf_ratio") },
        { title: "pe_ratio", name: this.getLabel("pe_ratio") }
      ],
      tableCols_s1_b: [
        { title: "benchmark", name: this.getLabel("benchmark_") },
        { title: "actual", name: this.getLabel("actual") }
      ],
      tableCols2_s1_b: [
        { title: "_benchmark", name: this.getLabel("benchmark_") },
        { title: "", name: this.getLabel("actual") }
      ],
      tableRows_s1_b: [
        { title: "p1_", name: this.getLabel("p1_") },
        { title: "p2_", name: this.getLabel("p2_") },
        { title: "p3_", name: this.getLabel("p3_") },
        { title: "p4_", name: this.getLabel("p4_") },
        { title: "p5_a_", name: this.getLabel("p5_A_") },
        { title: "p5_b_", name: this.getLabel("p5_B_") },
        { title: "p6_a_", name: this.getLabel("p6_A_") },
        { title: "p6_b_", name: this.getLabel("p6_B_") },
        // {title: "p7_a_", name: this.getLabel('p7_a_')},
        { title: "p7_b_", name: this.getLabel("p7_B_") },
        { title: "p8_a_", name: this.getLabel("p8_A_") },
        { title: "p8_b_", name: this.getLabel("p8_B_") },
        { title: "p9_", name: this.getLabel("p9_") },
        { title: "p10_", name: this.getLabel("p10_") },
        { title: "p11_", name: this.getLabel("p11_") }
      ],
      tableRows2_s1_b: [
        { title: "q1_a", name: this.getLabel("q1 A") },
        { title: "q1_b", name: this.getLabel("q1 B") },
        { title: "q1_c", name: this.getLabel("q1 C") },
        { title: "q1_d", name: this.getLabel("q1 D") }
      ],
      tableRows_s1_c: [
        {
          title: "cashflow_trends",
          name: "Cashflow Trends",
          hasBenchmark: 0,
          subFields: [
            {
              title: "latest_free_cash_flow",
              name: this.getLabel("latest_free_cash_flow"),
              isNumeric: 1,
              isColor: 0
            },
            {
              title: "last_year_free_cash_flow",
              name: this.getLabel("last_year_free_cash_flow"),
              isNumeric: 1,
              isColor: 0
            },
            {
              title: "no_of_positive_free_cash_flow_trends",
              name: this.getLabel("no_of_positive_free_cash_flow_trends"),
              isNumeric: 1,
              isColor: 0
            },
            {
              title: "total_free_cash_flow_trends",
              name: this.getLabel("total_free_cash_flow_trends"),
              isNumeric: 1,
              isColor: 0
            }
            // {title: "free_cash_flow_trends_last_nine_years", name: this.getLabel('free_cash_flow_trends_last_nine_years'), isNumeric: 0, isColor: 0},
          ]
        },
        {
          title: "shareholding/ownership",
          name: "Shareholding/Ownership",
          hasBenchmark: 1,
          subFields: [
            {
              title: "insider_acquisition",
              name: this.getLabel("insider_acquisition"),
              isNumeric: 1,
              isColor: 0
            },
            {
              title: "insider_disposal",
              name: this.getLabel("insider_disposal"),
              isNumeric: 1,
              isColor: 0
            },
            {
              title: "insider_trading",
              name: this.getLabel("insider_trading"),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "latest_promoter_holding",
              name: this.getLabel("latest_promoter_holding"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_promoter_holding_color",
              benchmark: "promoter_holding_benchmark"
            },
            {
              title: "latest_promoter_holding",
              name: this.getLabel("latest_promoter_holding_color"),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "Promoter_PledgeSharesPercentage",
              name: this.getLabel("Pledged Shares (%)"),
              isNumeric: 1,
              isColor: 0
            },
            // {title: "promoter_holding_benchmark", name: this.getLabel('promoter_holding_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "govtflag",
              name: this.getLabel("public_sector"),
              isNumeric: 0,
              isColor: 0
            },
            {
              title: "holding_company",
              name: this.getLabel("holding_company"),
              isNumeric: 1,
              isColor: 0
            }
          ]
        },
        {
          title: "macro_and_sector_trend",
          name: "Macro and Sector Trend",
          hasBenchmark: 0,
          subFields: [
            {
              title: "macro_trend",
              name: this.getLabel("macro_trend"),
              isNumeric: 0,
              isColor: 0
            }
          ]
        },
        {
          title: "moat_assessment",
          name: "Moat Assessment",
          hasBenchmark: 1,
          subFields: [
            {
              title: "latest_competative_advantage",
              name: this.getLabel("latest_competative_advantage"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_competative_advantage_color"
            },
            {
              title: "latest_competative_advantage_color",
              name: this.getLabel("latest_competative_advantage_color"),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "latest_consistency_analysis",
              name: this.getLabel("latest_consistency_analysis"),
              isNumeric: 0,
              isColor: 0,
              hasColor: 1,
              color: "latest_consistency_analysis_color"
            },
            {
              title: "latest_consistency_analysis_color",
              name: this.getLabel("latest_consistency_analysis_color"),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "latest_cyclical",
              name: this.getLabel("latest_cyclical"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_cyclical_color"
            },
            {
              title: "latest_cyclical_color",
              name: this.getLabel("latest_cyclical_color"),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "latest_trends_more_than_or_equal_five_yes",
              name: this.getLabel("Turnaround Possibility"),
              isNumeric: 0,
              isColor: 0,
              hasColor: 1,
              color: "latest_trends_more_than_or_equal_five_yes_color"
            },
            {
              title: "latest_trends_more_than_or_equal_five_yes_color",
              name: this.getLabel("Turnaround Possibility"),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "actual_market_share",
              name: this.getLabel("actual_market_share"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "actual_market_share_color",
              benchmark: "latest_market_share_benchmark"
            },
            {
              title: "actual_market_share_color",
              name: this.getLabel("actual_market_share_color"),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "last_year_market_share",
              name: this.getLabel("last_year_market_share"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "last_year_market_share_color"
            },
            {
              title: "last_year_market_share_color",
              name: this.getLabel("last_year_market_share_color"),
              isNumeric: 0,
              isColor: 1
            },
            // {title: "latest_market_share_benchmark", name: this.getLabel('latest_market_share_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "assets_heavy_or_light",
              name: this.getLabel("assets_heavy_or_light"),
              isNumeric: 0,
              isColor: 0
            },
            {
              title: "capex_management",
              name: this.getLabel("capex_management"),
              isNumeric: 0,
              isColor: 0
            }
          ]
        },
        {
          title: "capex(heavy_or_light)",
          name: "Capex (Heavy/Light)",
          hasBenchmark: 1,
          subFields: [
            {
              title: "capex_last_nine_years_per_cummulative_earning",
              name: this.getLabel(
                "capex_last_nine_years_per_cummulative_earning"
              ),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "capex_last_nine_years_per_cummulative_earning_color",
              benchmark:
                "capex_last_nine_years_per_cummulative_earning_benchmark"
            },
            // {title: "capex_last_nine_years_per_cummulative_earning_benchmark", name: this.getLabel('capex_last_nine_years_per_cummulative_earning_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "capex_last_nine_years_per_cummulative_earning_color",
              name: this.getLabel(
                "capex_last_nine_years_per_cummulative_earning_color"
              ),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "capex_last_nine_years_per_cummulative_nca",
              name: this.getLabel("capex_last_nine_years_per_cummulative_nca"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "capex_last_nine_years_per_cummulative_nca_color",
              benchmark: "capex_last_nine_years_per_cummulative_nca_benchmark"
            },
            // {title: "capex_last_nine_years_per_cummulative_nca_benchmark", name: this.getLabel('capex_last_nine_years_per_cummulative_nca_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "capex_last_nine_years_per_cummulative_nca_color",
              name: this.getLabel(
                "capex_last_nine_years_per_cummulative_nca_color"
              ),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "assets_heavy_or_light",
              name: this.getLabel("assets_heavy_or_light"),
              isNumeric: 0,
              isColor: 0
            }
          ]
        },
        {
          title: "capex_management",
          name: "Capex Management",
          hasBenchmark: 1,
          subFields: [
            {
              title: "increase_in_debt_per_capex_last_nine_years",
              name: this.getLabel("increase_in_debt_per_capex_last_nine_years"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "increase_in_debt_per_capex_last_nine_years_1_color",
              benchmark:
                "increase_in_debt_per_capex_last_nine_years_benchmark_1"
            },
            // {title: "increase_in_debt_per_capex_last_nine_years_benchmark_1", name: this.getLabel('increase_in_debt_per_capex_last_nine_years_benchmark_1'), isNumeric: 1, isColor: 0},
            {
              title: "increase_in_debt_per_capex_last_nine_years_1_color",
              name: this.getLabel(
                "increase_in_debt_per_capex_last_nine_years_1_color"
              ),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "capex_last_nine_years_per_cummulative_earning",
              name: this.getLabel(
                "capex_last_nine_years_per_cummulative_earning"
              ),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "capex_last_nine_years_per_cummulative_earning_1_color",
              benchmark:
                "capex_last_nine_years_per_cummulative_earning_benchmark_1"
            },
            // {title: "capex_last_nine_years_per_cummulative_earning_benchmark_1", name: this.getLabel('capex_last_nine_years_per_cummulative_earning_benchmark_1'), isNumeric: 1, isColor: 0, hasColor: 1, color: 'capex_last_nine_years_per_cummulative_earning_1_color'},
            {
              title: "capex_last_nine_years_per_cummulative_earning_1_color",
              name: this.getLabel(
                "capex_last_nine_years_per_cummulative_earning_1_color"
              ),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "capex_last_nine_years_per_cummulative_nca",
              name: this.getLabel("capex_last_nine_years_per_cummulative_nca"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "capex_last_nine_years_per_cummulative_nca_1_color",
              benchmark: "capex_last_nine_years_per_cummulative_nca_benchmark_1"
            },
            // {title: "capex_last_nine_years_per_cummulative_nca_benchmark_1", name: this.getLabel('capex_last_nine_years_per_cummulative_nca_benchmark_1'), isNumeric: 1, isColor: 0, hasColor: 1, color: 'capex_last_nine_years_per_cummulative_nca_1_color'},
            {
              title: "capex_last_nine_years_per_cummulative_nca_1_color",
              name: this.getLabel(
                "capex_last_nine_years_per_cummulative_nca_1_color"
              ),
              isNumeric: 0,
              isColor: 1
            }
          ]
        },
        {
          title: "capital_deployment",
          name: "Capital Deployment",
          hasBenchmark: 1,
          subFields: [
            {
              title: "actual_latest_roe",
              name: this.getLabel("actual_latest_roe"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_roe_color",
              benchmark: "latest_roe_benchmark"
            },
            // {title: "latest_roe_benchmark", name: this.getLabel('latest_roe_benchmark'), isNumeric: 1, isColor: 0, hasColor: 1, color: 'latest_roe_color'},
            {
              title: "latest_roe_color",
              name: this.getLabel("latest_roe_color"),
              isNumeric: 0,
              isColor: 1
            },
            {
              title: "p2_retained_earning",
              name: this.getLabel("retained_earning (P2)"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "retained_earning_color",
              benchmark: "retained_earning_benchmark"
            },
            // {title: "retained_earning_benchmark", name: this.getLabel('retained_earning_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "retained_earning_color",
              name: this.getLabel("retained_earning_color"),
              isNumeric: 0,
              isColor: 1
            }
          ]
        },
        {
          title: "leverage",
          name: "Leverage",
          hasBenchmark: 1,
          subFields: [
            {
              title: "actual_latest_total_debt_per_net_worth",
              name: this.getLabel("actual_latest_total_debt_per_net_worth"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_total_debt_per_net_worth_color",
              benchmark: "latest_total_debt_per_net_worth_benchmark"
            },
            // {title: "latest_total_debt_per_net_worth_benchmark", name: this.getLabel('latest_total_debt_per_net_worth_benchmark'), isNumeric: 1, isColor: 0, hasColor: 1, color: 'latest_total_debt_per_net_worth_color'},
            {
              title: "latest_total_debt_per_net_worth_color",
              name: this.getLabel("latest_total_debt_per_net_worth_color"),
              isNumeric: 0,
              isColor: 1
            }
          ]
        },
        {
          title: "efficiency",
          name: "Efficiency",
          hasBenchmark: 1,
          avg: 1,
          subFields: [
            {
              title: "latest_sales_per_invested_capital",
              name: this.getLabel("latest_sales_per_invested_capital"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_sales_per_invested_capital_color",
              benchmark: "latest_sales_per_invested_capital_benchmark",
              avg: "avg_sales_per_invested_capital",
              valuation: "valuation_trends_sales_per_invested_capital"
            },
            {
              title: "actual_latest_debtors_per_creditors",
              name: this.getLabel("latest_debtors_per_creditors"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_debtors_per_creditors_color",
              benchmark: "latest_debtors_per_creditors_benchmark",
              avg: "avg_debtors_per_creditors",
              valuation: "valuation_trends_debtors_per_creditors"
            },
            {
              title: "latest_debtors_per_creditors_color",
              name: this.getLabel("latest_debtors_per_creditors_color"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "latest_total_expenditure_per_creditors",
              name: this.getLabel("latest_total_expenditure_per_creditors"),
              isNumeric: 1,
              isColor: 0,
              benchmark: "benchmark_total_expenditure_per_creditors",
              avg: "avg_total_expenditure_per_creditors",
              valuation: "valuation_trends_total_expenditure_per_creditors"
            },

            {
              title: "latest_ns_per_debtors",
              name: this.getLabel("latest_ns_per_debtors"),
              isNumeric: 1,
              isColor: 0,
              benchmark: "benchmark_ns_per_debtors",
              avg: "avg_ns_per_debtors",
              valuation: "valuation_trends_ns_per_debtors"
            },

            {
              title: "latest_ns_per_inventory",
              name: this.getLabel("latest_ns_per_inventory"),
              isNumeric: 1,
              isColor: 0,
              benchmark: "benchmark_ns_per_inventory",
              avg: "avg_ns_per_inventory",
              valuation: "valuation_trends_ns_per_inventory"
            },

            {
              title: "latest_sales_per_invested_capital",
              name: this.getLabel("latest_sales_per_invested_capital"),
              isNumeric: 1,
              isColor: 0,
              benchmark: "benchmark_sales_per_invested_capital",
              avg: "avg_sales_per_invested_capital",
              valuation: "valuation_trends_sales_per_invested_capital"
            }
          ]
        },
        {
          title: "past_trends",
          name: "Past Trends",
          hasBenchmark: 1,
          subFields: [
            {
              title: "actual_sales_growth_cagr_10_years",
              name: this.getLabel("actual_sales_growth_cagr_10_years"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "sales_growth_cagr_10_years_color",
              benchmark: "sales_growth_cagr_10_years_benchmark"
            },
            // {title: "sales_growth_cagr_10_years_benchmark", name: this.getLabel('sales_growth_cagr_10_years_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "sales_growth_cagr_10_years_color",
              name: this.getLabel("sales_growth_cagr_10_years_color"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "actual_sales_growth_cagr_5_years",
              name: this.getLabel("actual_sales_growth_cagr_5_years"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "sales_growth_cagr_5_years_color",
              benchmark: "sales_growth_cagr_5_years_benchmark"
            },
            // {title: "sales_growth_cagr_5_years_benchmark", name: this.getLabel('sales_growth_cagr_5_years_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "sales_growth_cagr_5_years_color",
              name: this.getLabel("sales_growth_cagr_5_years_color"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "actual_earnings_growth_cagr_10_years",
              name: this.getLabel("actual_earnings_growth_cagr_10_years"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "earnings_growth_cagr_10_years_color",
              benchmark: "earnings_growth_cagr_10_years_benchmark"
            },
            // {title: "earnings_growth_cagr_10_years_benchmark", name: this.getLabel('earnings_growth_cagr_10_years_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "earnings_growth_cagr_10_years_color",
              name: this.getLabel("earnings_growth_cagr_10_years_color"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "actual_earnings_growth_cagr_5_years",
              name: this.getLabel("actual_earnings_growth_cagr_5_years"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "earnings_growth_cagr_5_years_color",
              benchmark: "earnings_growth_cagr_5_years_benchmark"
            },
            // {title: "earnings_growth_cagr_5_years_benchmark", name: this.getLabel('earnings_growth_cagr_5_years_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "earnings_growth_cagr_5_years_color",
              name: this.getLabel("earnings_growth_cagr_5_years_color"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "actual_eps_growth_cagr_5_years",
              name: this.getLabel("actual_eps_growth_cagr_5_years"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "eps_growth_cagr_5_years_color",
              benchmark: "eps_growth_cagr_5_years_benchmark"
            },
            // {title: "eps_growth_cagr_5_years_benchmark", name: this.getLabel('eps_growth_cagr_5_years_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "eps_growth_cagr_5_years_color",
              name: this.getLabel("eps_growth_cagr_5_years_color"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "actual_eps_growth_cagr_10_years",
              name: this.getLabel("actual_eps_growth_cagr_10_years"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "eps_growth_cagr_10_years_color",
              benchmark: "eps_growth_cagr_10_years_benchmark"
            },
            // {title: "eps_growth_cagr_10_years_benchmark", name: this.getLabel('eps_growth_cagr_10_years_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "eps_growth_cagr_10_years_color",
              name: this.getLabel("eps_growth_cagr_10_years_color"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "sector_sales_cagr_5_years",
              name: this.getLabel("sector_sales_cagr_5_years"),
              isNumeric: 1,
              isColor: 0
            },
            // {title: "eps_growth_cagr_5_years_benchmark", name: this.getLabel('eps_growth_cagr_5_years_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "sector_sales_cagr_5_years",
              name: this.getLabel("sector_sales_cagr_5_years"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "sector_sales_cagr_10_years",
              name: this.getLabel("sector_sales_cagr_10_years"),
              isNumeric: 1,
              isColor: 0
            },
            // {title: "eps_growth_cagr_10_years_benchmark", name: this.getLabel('eps_growth_cagr_10_years_benchmark'), isNumeric: 1, isColor: 0},
            {
              title: "sector_sales_cagr_5_years_color",
              name: this.getLabel("sector_sales_cagr_5_years_color"),
              isNumeric: 0,
              isColor: 1
            }
          ]
        },
        {
          title: "EBITDA",
          name: "EBITDA Margin",
          hasBenchmark: 1,
          avg: 1,
          subFields: [
            // {title: "actual_latest_ebitDA_per_sales", name: this.getLabel('actual_ebitDA_per_sales'), isNumeric: 1, isColor: 0, hasColor: 1, color:'latest_ebitDA_per_sales_color', benchmark: 'latest_ebitDA_per_sales_benchmark'},
            {
              title: "latest_ebitDA_per_sales",
              name: this.getLabel("latest_ebitDA_per_sales"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_ebitDA_per_sales_color",
              benchmark: "latest_ebitDA_per_sales_benchmark",
              avg: "avg_ebitDA_per_sales",
              valuation: "valuation_trends_ebitDA_per_sales"
            }
            // {title: "latest_ebitDA_per_sales_benchmark", name: this.getLabel('ebitDA_per_sales_benchmark'), isNumeric: 1, isColor: 0},
            // {title: "valuation_trends_ebitDA_per_sales", name: this.getLabel('ebitDA_per_sales'), isNumeric: 0, isColor: 0},
            // {title: "avg_ebitDA_per_sales", name: this.getLabel('avg_ebitDA_per_sales'), isNumeric: 1, isColor: 0},
          ]
        },
        {
          title: "Governance",
          name: "Governance",
          hasBenchmark: 1,
          avg: 1,
          subFields: [
            {
              title: "latest_lna_per_net_worth",
              name: this.getLabel("latest_lna_per_net_worth"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_lna_per_net_worth_color",
              benchmark: "latest_lna_per_net_worth_benchmark",
              avg: "avg_lna_per_net_worth",
              valuation: "valuation_trends_lna_per_net_worth"
            },
            {
              title: "latest_lna_per_net_worth_color",
              name: this.getLabel("latest_lna_per_net_worth_color"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "actual_latest_cfo_per_ebitda",
              name: this.getLabel("actual_latest_cfo_per_ebitda"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_cfo_per_ebitda_color",
              benchmark: "latest_cfo_per_ebitda_benchmark",
              avg: "avg_cfo_per_ebitDA",
              valuation: "valuation_trends_cfo_per_ebitDA"
            },
            {
              title: "latest_cfo_per_ebitda_color",
              name: this.getLabel("latest_cfo_per_ebitda_color"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "actual_latest_tax_per_pbt",
              name: this.getLabel("actual_latest_tax_per_pbt"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_tax_per_pbt_color",
              benchmark: "latest_tax_per_pbt_benchmark"
            },
            {
              title: "latest_tax_per_pbt_color",
              name: this.getLabel("latest_tax_per_pbt_color"),
              isNumeric: 0,
              isColor: 1
            },

            {
              title: "latest_total_taxes_accounted",
              name: this.getLabel("latest_total_taxes_accounted"),
              isNumeric: 1,
              isColor: 0
            },
            {
              title: "latest_total_taxes_paid",
              name: this.getLabel("latest_total_taxes_paid"),
              isNumeric: 1,
              isColor: 0,
              hasColor: 1,
              color: "latest_total_taxes_paid_color",
              benchmark: 1
            },
            {
              title: "latest_total_taxes_paid_color",
              name: this.getLabel("latest_total_taxes_paid_color"),
              isNumeric: 0,
              isColor: 1
            }
          ]
        },
        {
          title: "quartely_trends",
          name: "Quartely Trends",
          subFields: [
            {
              title: "L_qtr_YOY_net_sales",
              name: this.getLabel("L_qtr_YOY_net_sales"),
              isNumeric: 0,
              isColor: 0
            },
            {
              title: "L-1_qtr_YOY_net_sales",
              name: this.getLabel("L-1_qtr_YOY_net_sales"),
              isNumeric: 0,
              isColor: 0
            },

            {
              title: "L_qtr_YOY_eps",
              name: this.getLabel("L_qtr_YOY_eps"),
              isNumeric: 0,
              isColor: 0
            },
            {
              title: "L-1_qtr_YOY_eps",
              name: this.getLabel("L-1_qtr_YOY_eps"),
              isNumeric: 0,
              isColor: 0
            }
          ]
        }
      ],
      curDate: new Date()
    };
  },
  methods: {
    getRawData() {
      this.rawData = {};
      // this.rawDataApi + this.company.co_code,
      let myself = this;
      http.get("formulas/" + this.company.co_code, {}, (error, response) => {
        myself.rawData = response;
        console.log(typeof response, response);
        var tabs = Object.keys(myself.rawData);
        console.log("tabs", tabs);
        tabs.forEach((val, index) => {
          // if (this.checkNotInArray(this.removedTabs, val)) {
          if (this.checkInArray(this.activeTabs, val)) {
            // console.log(val.split("_"));
            myself.tabs.push({
              title: val,
              name: this.getLabel(val),
              sort_order:
                val === "p1"
                  ? 0
                  : val === "p2"
                  ? 1
                  : val === "p3"
                  ? 2
                  : val === "p4"
                  ? 3
                  : val === "p5_a"
                  ? 4
                  : val === "p5_b"
                  ? 5
                  : val === "p6_a"
                  ? 6
                  : val === "p6_b"
                  ? 7
                  : val === "p7_a"
                  ? 8
                  : val === "p7_b"
                  ? 9
                  : val === "p8_a"
                  ? 10
                  : val === "p8_b"
                  ? 11
                  : val === "p9"
                  ? 12
                  : val === "p10"
                  ? 13
                  : val === "p11"
                  ? 14
                  : val === "q1"
                  ? 16
                  : val === "q1_a"
                  ? 17
                  : val === "q1_b"
                  ? 18
                  : val === "q1_a_or_b"
                  ? 18
                  : val === "q1_c"
                  ? 19
                  : val === "q1_d"
                  ? 20
                  : val === "s1"
                  ? 21
                  : val === "return_analysis"
                  ? 22
                  : val === "return_one_analysis"
                  ? 23
                  : val === "years"
                  ? 24
                  : 9999
            });
          }
        });
        myself.tabs = myself.sorted_fields_asc(myself.tabs, "sort_order");
        myself.actTab = myself.tabs[0].title;
        console.log("Tabs", myself.tabs);
        console.log(
          "Tab Data",
          myself.tabs[0].title,
          myself.rawData,
          myself.rawData[myself.tabs[0].title]
        );
        console.log("Active tab", myself.tabs[0].title);
        // this.getTableFields(this.rawData[this.tabs[0].title]);
        this.generateFields(myself.tabs[0]);
        //TODO:: add company updates into our array in future
        if (
          this.rawData.sectorcode === "00000006" ||
          this.rawData.sectorcode === "00000026"
        ) {
          console.log("Its Bank or Finance");
          // this.tableRows_p8_b.splice(this.tableRows_p8_b.indexOf("relative_strength_ranking"), 1);
          // this.tableRows_p8_b.push("relative_strength_measure");
          // this.tableRows_p10.splice(this.tableRows_p10.indexOf("long_term_debt_by_assets_of_latest_vs_prev_year"), 1);
          this.tableRows_p10.push(
            "total_debt_by_assets_of_latest_vs_prev_year"
          );
        } else {
          console.log("Its Not Bank or Finance");
          // this.tableRows_p8_b.splice(this.tableRows_p8_b.indexOf("relative_strength_measure"), 1);
          // this.tableRows_p8_b.push("relative_strength_ranking");
          // this.tableRows_p10.splice(this.tableRows_p10.indexOf("total_debt_by_assets_of_latest_vs_prev_year"), 1);
          this.tableRows_p10.push(
            "long_term_debt_by_assets_of_latest_vs_prev_year"
          );
        }
      });
    },
    setAccordian(key, ind, type) {
      console.log(key, "index", ind, this.tableFields[ind]);
      console.log(this.tableFields);
      if (this.selRowInd != ind) {
        console.log("Not same");
        this.tableFields[this.selRowInd].open = false;
        this.selRowInd = ind;
        this.tableFields[ind].open = !this.tableFields[ind].open;
        // this.getRawData();
      } else if (this.selRowInd == ind) {
        console.log("same");
        this.selRowInd = ind;
        this.tableFields[ind].open = !this.tableFields[ind].open;
      }
      console.log(this.tableFields);
    },
    getTableData(data) {
      // console.log("years", data);
      this.clearData();
      var tableCols = Object.keys(data);
      console.log("tableCols", tableCols);
      tableCols.forEach((val, key) => {
        console.log(val, key, val.search("year"), val.search("average"));
        if (
          val.search("year") === -1 &&
          val.search("average") === -1 &&
          val.search("L-1") === -1 &&
          val.search("L-2") === -1 &&
          val.search("L-3") === -1 &&
          val.search("S") === -1 &&
          val.search("latest") === -1 &&
          val.search("weight") === -1 &&
          val.search("Year") === -1
        ) {
          console.log("No match", val);
          // if (parseInt(val) !== this.curDate.getFullYear() - 1) {
          this.tableCols.push({
            title: val,
            name: this.getLabel(val),
            open: false,
            isAccord: true,
            sort_order: parseInt(val),
            arrange_order: key
          });
          // }
        } else if (val.search("year") !== -1) {
          this.tableColsYears.push({
            title: val,
            name: this.getLabel(val),
            open: false,
            isAccord: true,
            sort_order: parseInt(val.replace(/^\D+/g, "")),
            arrange_order: key
          });
        } else if (val.search("average") !== -1) {
          this.tableColsAvg.push({
            title: val,
            name: this.getLabel(val),
            open: false,
            isAccord: true,
            sort_order: 1,
            isNumeric: true
          });
        }
      });
      // console.log("Projected 1", this.tableColsP1);
      this.tableCols = this.sorted_fields_desc(this.tableCols, "sort_order");
      this.tableColsYears = this.sorted_fields_asc(
        this.tableColsYears,
        "sort_order"
      );
      console.log(
        "Years data",
        this.tableCols,
        this.tableColsYears,
        this.tableColsAvg
      );
      if (this.tableColsYears.length > 0) {
        var tablRows = Object.keys(
          data[this.tableCols[this.tableCols.length - 1].title]
        );
        tablRows.forEach((val, key) => {
          this.tableRows.push({
            title: val,
            name: this.getLabel(val),
            sort_order: key,
            arrange_order: key
          });
        });
        var tablRowsYrs = Object.keys(data[this.tableColsYears[0].title]);
        tablRowsYrs.forEach((val, key) => {
          this.tableRowsYears.push({
            title: val,
            name: this.getLabel(val),
            sort_order: key,
            arrange_order: key
          });
        });
        var tablRowsAvg = Object.keys(data[this.tableColsAvg[0].title]);
        console.log("Keys", tablRowsAvg);
        tablRowsAvg.forEach((val, key) => {
          this.tableRowsAvg.push({
            title: val,
            name: this.getLabel(val),
            sort_order: 0,
            arrange_order: key
          });
        });
        this.tableRowsAvg = this.sorted_fields_asc(this.tableRowsAvg, "title");
        console.log("Cols", this.tableRowsAvg);
        var avgAddCols = Object.keys(
          data[this.tableColsAvg[0].title][this.tableRowsAvg[0].title]
        );
        avgAddCols.forEach((val, key) => {
          this.tableColsAvg.push({
            title: val,
            name: this.getLabel(val),
            sort_order: key,
            arrange_order: key,
            isNumeric: val === "verdict" ? false : true
          });
        });
        var rawTableFields = Object.keys(data[this.tableCols[0].title]);
        console.log(
          "RawFields",
          rawTableFields,
          this.tableCols[0].title,
          this.tableColsAvg
        );
        rawTableFields.forEach((val, key) => {
          if (tablRows.length > 0 && this.checkNotInArray(tablRows, val)) {
            // console.log("valnot in", val);
            this.tableFieldsRaw.push({
              title: val,
              name: this.getLabel(val),
              sort_order: key,
              arrange_order: key
            });
          }
          // console.log("Count", this.tableFieldsRaw.length, tablRows.length);
        });
      }
      // console.log(
      //   this.tableRows,
      //   this.tableRowsYears,
      //   this.tableRowsAvg,
      //   this.tableColsAvg
      // );
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab, oldTab);
      this.selTab = tabIndex;
      var actTab = newTab.title.split(" ").join("_");
      this.actTab = actTab.charAt(0).toLowerCase() + actTab.slice(1);
      console.log("act tab", this.actTab);
      console.log(newTab.title, "raw", this.rawData[this.tabs[tabIndex].title]);
      this.generateFields(newTab);
    },
    generateFields(tab) {
      console.log("Tab", this.selTab, tab.title);
      if (tab.title.toLowerCase() === "years") {
        this.getTableData(this.rawData[this.tabs[this.selTab].title]);
      } else if (tab.title.toLowerCase() === "p11") {
        this.getP11data();
      } else if (tab.title.toLowerCase() === "p9") {
        this.getP9data();
      } else if (tab.title.toLowerCase() === "s1") {
        this.getS1data();
      } else if (tab.title.toLowerCase() === "return_analysis") {
        this.getRAdata();
      } else if (tab.title.toLowerCase() === "return_one_analysis") {
        this.getRAdata();
      } else if(tab.title.toLowerCase() !== "q1_a_or_b") {
        this.getPData();
      }
    },
    getCalculatedData(pdata) {
      var ptableCols = [];
      pdata.forEach((val, key) => {
        if (val != "sum" && val != "final_verdict") {
          ptableCols.push({
            title: val,
            name: this.getLabel(val),
            open: false,
            isAccord: true,
            sort_order:
              val == "score"
                ? 3
                : val == "benchmark"
                ? 1
                : val == "actual"
                ? 2
                : val == "weight"
                ? 4
                : val == "weighted_score"
                ? 5
                : val == "super_weight"
                ? 6
                : val == "super_sum"
                ? 7
                : 9999,
            isNumeric: true
          });
        }
      });
      return ptableCols;
    },
    getP9data() {
      this.tableColsP = [];
      this.tableP9Rows = [];
      var p9Rows = Object.keys(this.rawData[this.actTab]);
      var ptableCols = [];
      p9Rows.forEach((val, key) => {
        // if (val != "super_sum" && val != "super_weight") {
        ptableCols.push({
          title: val,
          name: this.getLabel(val),
          sort_order: "",
          subFields: []
        });
        // }
      });
      console.log("P9rows", ptableCols);
      this.tableP9Rows = ptableCols;
      this.tableP9Rows.forEach((val, key) => {
        console.log(this.actTab, val);
        var catRows = Object.keys(this.rawData[this.actTab][val.title]);
        console.log("catRows", catRows);
        var subCols = [];
        catRows.forEach((value, k) => {
          subCols.push({
            title: value,
            name: this.getLabel(value),
            sort_order: "",
            subFields: []
          });
        });
        this.tableP9Rows[key]["subFields"] = subCols;
      });
      console.log(
        "this.tableP9Rows",
        this.tableP9Rows,
        this.actTab,
        this.tableP9Rows[0].title,
        this.tableP9Rows[0]["subFields"][0].title
      );
      var tableColsP = Object.keys(
        this.rawData[this.actTab][this.tableP9Rows[0].title][
          this.tableP9Rows[0]["subFields"][0].title
        ]
      );
      console.log("TableCols", tableColsP);
      // tableColsP.forEach((value, k) => {
      this.tableColsP.push(
        {
          title: "actual",
          name: this.getLabel("actual"),
          sort_order: 1
        },
        {
          title: "rank",
          name: this.getLabel("rank"),
          sort_order: 2
        }
      );
      // });
      console.log("this.tableColsP", this.tableColsP);
    },
    getP11data() {
      var p11Rows = Object.keys(this.rawData[this.actTab]);
      var ptableCols = [];
      p11Rows.forEach((val, key) => {
        if (val != "super_sum" && val != "super_weight" && val != "rating") {
          ptableCols.push({
            title: val,
            name: this.getLabel(val),
            sort_order: "",
            subFields: []
          });
        }
      });
      console.log("P11rows", ptableCols);
      this.tableP11Rows = ptableCols;
      var p11keys = Object.keys(this.rawData[this.actTab][ptableCols[0].title]);
      this.tableColsP = this.getCalculatedData(
        Object.keys(this.rawData[this.actTab][ptableCols[0].title])
      );
      this.tableColsP = this.sorted_fields_asc(this.tableColsP, "sort_order");
      console.log("p11keys", p11keys, this.tableColsP);
      this.tableP11Rows.forEach((val, key) => {
        // console.log(this.actTab, val);
        var catRows = Object.keys(
          this.rawData[this.actTab][val.title][this.tableColsP[0]["title"]]
        );
        // console.log("catRows", catRows);
        var subCols = [];
        catRows.forEach((value, k) => {
          if (
            value != "sum" &&
            value != "super_sum" &&
            value != "super_weight"
          ) {
            subCols.push({
              title: value,
              name: this.getLabel(value),
              sort_order: "",
              subFields: []
            });
          }
        });
        this.tableP11Rows[key]["subFields"] = subCols;
      });
      console.log("this.tableP11Rows", this.tableP11Rows);
    },
    getS1data() {
      var tableRows_s1 = Object.keys(this.rawData[this.actTab]);
      // console.log(tableRows_s1);
      tableRows_s1.forEach((val, key) => {
        // console.log("Key ", val);
        if (val.indexOf("color") === -1) {
          this.tableRows_s1.push({
            title: val,
            name: this.getCustomLabel(val)
              ? this.getCustomLabel(val)
              : this.getLabel(val),
            sort_order: key,
            arrange_order: key
          });
        }
      });
      this.tableRows_s1 = this.sorted_fields_asc(this.tableRows_s1, "title");
      console.log("S1 Rows", this.tableRows_s1);
    },
    getPData() {
      this.clearData();
      if(this.actTab !== 'quarterly_trends'){
      this.tableColsP = this.getCalculatedData(
        Object.keys(this.rawData[this.actTab])
      );
      } else {
        this.tableColsP = this.getCalculatedData(
        Object.keys(this.rawData['p1'])
      );
      }
      this.tableColsP = this.sorted_fields_asc(this.tableColsP, "sort_order");
      console.log("Projeted cols", this.tableColsP);
    },
    getRAdata() {
      this.tableRowsRA = [
        { title: "at_average_pe", name: "IRR (at average PE)" },
        { title: "at_current_pe", name: "IRR (at current PE)" },
        { title: "at_highest_pe", name: "IRR (at highest PE)" },
        { title: "at_lowest_pe", name: "IRR (at lowest PE)" }
      ];
      this.tableRowsRASubRow = [
        { title: "outflow_mkt_cap", name: "Outflow - mkt cap" },
        { title: "inflow_dividend", name: "Inflow Dividend" },
        { title: "net_cash_flow", name: "Net cashflows" },
        { title: "irr", name: "" }
      ];
    },
    clearData() {
      this.tableCols = [];
      this.tableRows = [];
      this.tableColsYears = [];
      this.tableRowsYears = [];
      this.tableColsAvg = [];
      this.tableRowsAvg = [];
      this.tableColsP = [];
      this.tableP11Rows = [];
      this.tableP9Rows = [];
      this.tableFieldsRaw = [];
      this.tableRows_s1 = [];
      this.tableRowsRA = [];
      this.tableRowsRASubRowF = [];
    },
    updateCalculatedData() {
      console.log("Update");
    }
  },
  computed: {
    getCurrentTabData: function() {
      // if(this.actTab==='q1_a'){
      return this["tableRows_" + this.actTab];
      // }
      // else if(this.actTab==='q1_b'){
      //   return this.tableRows_q1_b;
      // } else if(this.actTab==='q1_c'){
      //   return this.tableRows_q1_c;
      // } else if(this.actTab==='q1_d'){
      //   return this.tableRows_q1_d;
      // }
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
  vertical-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/company/calculateddata.vue